import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Injector, Input, NgZone, OnInit, Output, TemplateRef, ViewChild} from "@angular/core";
import {MatDialog} from '@angular/material/dialog';
import {ToastrService} from "ngx-toastr";
import {TranslocoService} from "@ngneat/transloco";
import {Compbaser} from "../../../components/compbaser";
import {debounceTime, filter, map, take} from "rxjs/operators";
import {Subject, timer} from "rxjs";
import {Router} from "@angular/router";
import {DialogPopComponent} from "../../../components/dialog-pop/dialog-pop.component";
import {DialogHotkeysComponent} from "../../../components/dialog-hotkeys/dialog-hotkeys.component";
import {DialogImportingComponent} from "../../../components/dialog-importing/dialog-importing.component";
import {MatMenuTrigger} from "@angular/material/menu";
import {IGroupCollection} from "../../../interfaces/enterprise-interface";
import {AccessService, AppService, ContainerService, LocalStoreService, SceneService, StoreSelectorsService, UserService} from "../../../services";
import {SelectionModel} from "@angular/cdk/collections";
import {TouchLib} from "../touch/touchLib";
import {FaIconLibrary} from "@fortawesome/angular-fontawesome";
import {
    DuplicateCommand,
    EnumConnectionType,
    EnumWizardUpgradeToasts,
    ExperienceLevelType,
    FileObj,
    Hiddenlines,
    IAccessTable,
    IAppSettingsWrap,
    ICRUDRecord,
    Id,
    IGuideLines,
    ILockedRecord,
    IOS,
    IPlayerProps,
    IResource,
    IResourceUpload,
    ISceneBlock,
    ISceneItemPosition,
    ISceneItemsUpdate,
    ISceneTreeSliceResults,
    ISocialToken,
    IStationData,
    IUIDuplicationBlock,
    IUser,
    UploadStatus,
    ISceneBreadcrumb
} from "../../../interfaces";
import {actionAddResources, actionAddSceneItem, actionCRUDScene, actionDuplicateScene, actionDuplicateSceneCommand, actionPlaySweepLine, actionSceneJumpLinked, actionSelectedSceneItemId, actionSocialPost, actionSocialPostSuccess, actionUpdateSceneItem, actionUpdateSceneItemGroup, actionSceneBreadcrumbsSet, actionSelectedSceneId, actionSelectedSceneTouchId} from '../../../store/actions/user.actions';
import {IBlockLabelProp, IMPORT_WAIT_SECONDS, MOVE_DIFF, RESIZE_DIFF, SCENE_SAVING_INTERVAL} from "../scene-blocks/block-constants";
import {ADDBLOCK_OFFSET, checkLockedScene, compareIds, convertBooleanToNumbers, convertNumberToBoolean, copyTextClipboard, createScenePreviewUrl, DRAG_ITEM_SIZE, formatBytes, getGuidelineFromPattern, getPlayerIdInScene, isMainTouchScene, isMimeTypeExists, isNullOrUndefOrEmpty, isSceneButNotSubScene, isStringBasedJson, isTruthy, KEY_CODE, mimeSwap, playSound, popupWindow, preprocessSceneRecord, RULER_ZOOMS, sceneItemInvalid, SUPPORTED_FILE_TYPES, TOAST_FASTER} from "../../../common";
import {faLocationArrow, faRightFromBracket, faExpand, faArrowDown, faArrowUp, faBorderNone, faCopy, faCut, faEye, faEyeSlash, faFloppyDisk, faHand, faImage, faLink, faLock, faLockOpen, faMagnet, faPaste, faRedo, faSortAmountDown, faSortAmountUp, faSquare, faTrashAlt, faUndo} from "@fortawesome/free-solid-svg-icons";
import {faFloppyDisk as farFloppyDisk, faHand as farHand} from '@fortawesome/free-regular-svg-icons';
import {DialogQrGenerateComponent} from "../../../components/dialog-qr-generate/dialog-qr-generate.component";
import {DialogCodeComponent} from "../../../components/dialog-code/dialog-code.component";
import {Memoizee} from "../../../decorators/memoizee-decorator";
import {Lib} from "../../../../libs/Lib";
import html2canvas from "html2canvas";
import {faDropbox, faFacebook, faGoogleDrive, faGooglePlus, faInstagram, faLinkedin, faPinterest, faReddit, faTelegram, faTiktok, faTwitter, faYoutube} from "@fortawesome/free-brands-svg-icons";
import * as htmlToImage from 'html-to-image';
import * as _ from "lodash";
import {ActionsSubject} from "@ngrx/store";
import {ofType} from "@ngrx/effects";
import {StationAddPlayerComponent} from "../../stations/station-add-player/station-add-player.component";
import {AiService} from "../../../services/ai/ai.service";
import { DialogPreviewComponent, DialogPreviewData } from "../../../components/dialog-preview/dialog-preview.component";
import { DialogPaletteSelectorComponent } from "../../../components/dialog-palette-selector/dialog-palette-selector.component";
import { ColorPalette, PaletteService } from "../../../services/palette.service";

declare var jQuery: any;
declare var DragSelect: any;

interface SubChange {
    selection?: any;
    layer?: 'Up' | 'Down' | 'Top' | 'Bottom';
}

@Component({
    selector: 'app-scene-builder',
    templateUrl: './scene-builder.component.html',
    styleUrls: ['./scene-builder.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SceneBuilderComponent extends Compbaser implements OnInit {

    readonly tooltipPos = 'below';
    readonly faCopy = faCopy;
    readonly faPaste = faPaste;
    readonly faCut = faCut;
    readonly faEyeSlash = faEyeSlash;
    readonly faEye = faEye;
    readonly faLock = faLock;
    readonly faLockOpen = faLockOpen;
    readonly faArrowUp = faArrowUp;
    readonly faArrowDown = faArrowDown;
    readonly faSortAmountDown = faSortAmountDown;
    readonly faSortAmountUp = faSortAmountUp;
    readonly faTrashAlt = faTrashAlt;
    readonly faUndo = faUndo;
    readonly faRedo = faRedo;
    readonly faBorderNone = faBorderNone;
    readonly faLink = faLink;
    readonly faImage = faImage;
    readonly faMagnet = faMagnet;
    readonly faFloppyDisk = farFloppyDisk;
    readonly faHand = faHand;
    readonly farHand = farHand;
    readonly faPinterest = faPinterest;
    readonly faReddit = faReddit;
    readonly faYouTube = faYoutube;
    readonly faTwitter = faTwitter;
    readonly faFacebook = faFacebook;
    readonly faGoogleDrive = faGoogleDrive;
    readonly faDropbox = faDropbox;
    readonly faTiktok = faTiktok;
    readonly faInstagram = faInstagram;
    readonly faTelegram = faTelegram;
    readonly faGooglePlus = faGooglePlus;
    readonly faLinkedin = faLinkedin;
    readonly faLocationArrow = faLocationArrow;
    readonly faExpand = faExpand;
    readonly faRightFromBracket = faRightFromBracket;

    readonly percentages = [25, 50, 75, 100, 150, 200];

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    guidelines = {
        horizontal: [],
        vertical: [],
    };
    hidelines: Hiddenlines = {
        horizontal: [],
        vertical: [],
    };


    savedIcon = false;
    previousLinkedSceneId = null;
    previousSlidesSceneId = null;
    editorElement;
    viewElement;
    pageElement;
    editorWidth: number;
    editorHeight: number;
    sceneItems: Array<ISceneItemPosition> = [];
    sceneSlice: ISceneTreeSliceResults;
    scenes: IPlayerProps[];
    sceneData: IPlayerProps;
    accessConfig: IAccessTable;
    groupCollection: IGroupCollection;
    changeSelect = false;
    selectedIndexList: Array<number> = [];
    selectedItemIds: Array<string> = [];
    sceneMimeShort;
    drag;
    resolution = 1;
    mousePosition = [0, 0, 0, 0];
    zoomIndex = 1;
    zoom = 1;
    moveElements: any = [];
    isOrdering = false;
    isMouseOut = true;
    isCut = false;
    isCopy = false;
    disableUndo = true;
    disableRedo = true;
    isShowLines = false;
    isEditorFocus = false;
    guidelineOpacity = 1;
    sceneCheckeredBackground = '1';
    isFullFeatures;
    iOS: IOS;
    selectedSceneId;
    pasteData: {
        topLeftXY: number[],                    // top-left position of selected item or group by copy(or cut)
        clipboardBlocks: Array<ISceneTreeSliceResults> // scene tree list of selected scene items to be pasted
    } = {
        topLeftXY: [0, 0],
        clipboardBlocks: []
    };
    pasteCount = 1;
    dialogRef;
    selectedSceneItemId: Id;
    isDraggingItem = false;
    players: ISceneBlock[] = [];
    saveMode = {
        'saveSceneOnExit': true,
        'saveSceneTimer': false,
        'saveSceneManual': false,
    };
    studioId: string;
    coreAppData: IAppSettingsWrap;
    contextMenuPosition = {x: '0px', y: '0px'};
    zoom_cnt = RULER_ZOOMS.length;
    preSelectedItem = [];
    singleClick = true;
    textEditMode = false;
    sliderSceneId: string;

    // lockedRecord: ILockedRecord;
    lockedScene;
    enableBackground = false;
    lastSelectedTargetId;
    isMouseDragging = false;
    isMouseDown = false;
    isMultiMode = false;
    selectedByTree = false;
    showDirections = false;

    rulerMinWidth = 1200;
    rulerMinHeight = 1200;

    labelCount = 0;

    previewSizeX;
    previewSizeY;
    previewPercent = 100;
    previewMode = 'size';
    isFirefox = false;
    sceneMimeType: string;
    isMainScene = true;
    user: IUser;

    // scene drag variables
    dragPos = {top: 0, left: 0, x: 0, y: 0};
    draggingScene = false;
    dragSceneEnabled = false;
    previewSceneId = null;
    rememberSelection = false;
    selectedPreviewScene;

    socialMediaSelection: SelectionModel<string>;
    socialMediaResource: IResource;
    socialMediaResourceName = '';
    socialMediaTitle = '';
    socialPostDisabled = true;
    socialPosting = false;

    scrWidth: number;
    toolbarHidden = false;
    breadcrumbs: ISceneBreadcrumb[] = [];
    private subSelection = new Subject<SubChange>();

    // @ViewChild("previewEmbeddedModal", {read: TemplateRef}) previewEmbeddedModal: TemplateRef<any>;

    @ViewChild("aboutScene", {read: TemplateRef}) aboutScene: TemplateRef<any>;
    @ViewChild("sharedPreviewModal", {read: TemplateRef}) sharedPreviewModal: TemplateRef<any>;
    @ViewChild("guidelineModal", {read: TemplateRef}) guidelineModal: TemplateRef<any>;
    @ViewChild("contextMenuTrigger", {read: MatMenuTrigger, static: true}) contextMenu: MatMenuTrigger;
    @ViewChild("overflowMenuTrigger", {read: MatMenuTrigger}) overflowMenuTrigger: MatMenuTrigger;
    @ViewChild("appSceneSocialTokenApp", {read: TemplateRef}) appSceneSocialTokenApp: TemplateRef<any>;
    @ViewChild('appSceneSocialTokenApp', {static: false}) appSceneSocialTokenApp2;

    @Output() toggleMinimize: EventEmitter<any> = new EventEmitter<any>(); // sean_add
    @Output() playPreviewEvent = new EventEmitter<DialogPreviewData>();
    @Output() touchAction = new EventEmitter<any>();

    @Input()
    set setSelectedSceneId(i_setSelectedSceneId: Id) {
        // this.selectedSceneId = i_setSelectedSceneId;
        // this.previewSceneId = this.selectedSceneId;
        // this.openRecordForEdit();
    }

    @Input()
    set setSceneData(i_sceneData: IPlayerProps) {
        this.sceneData = i_sceneData;
        this.selectedSceneId = i_sceneData.Player.$.id;
        this.previewSceneId = this.selectedSceneId;
        this.editorHeight = +i_sceneData.Player.Data[0].Layout[0].$.height;
        this.editorWidth = +i_sceneData.Player.Data[0].Layout[0].$.width;

        this.processScenePlayers(i_sceneData);
    }

    @Input()
    set setSelectedSceneItemId(i_value) {
        // if (!i_value) return;
        // if (i_value != this.selectedSceneId) {
        //     this.changeTargetById(i_value);
        // }
        this.selectedSceneItemId = i_value;
    }

    @Input()
    set setSelectedSceneIdDataChanged(i_value: ISceneTreeSliceResults) {
        if (!i_value) return;
        setTimeout(() => {
            this.changeSceneSlice(i_value);
        });
    }

    @Input() slideEditMode = false;

    @HostListener('mouseenter') onMouseEnter() {
        this.isEditorFocus = true;
    }

    @HostListener('mouseleave') onMouseLeave() {
        this.isEditorFocus = false;
    }

    @HostListener('document:contextmenu', ['$event'])
    onContextmenu(event) {
        if (this.contextMenu.menuOpen) {
            event.preventDefault();
            event.stopPropagation();

            this.contextMenu.closeMenu();
            // this.onRightClickSceneItem(event);
        }
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
        this.scrWidth = window.innerWidth;

        // Close overflow menu when window is resized/moved
        if (this.overflowMenuTrigger?.menuOpen) {
            this.overflowMenuTrigger.closeMenu();
        }
    }

    constructor(
        private zone: NgZone,
        private storeSelector: StoreSelectorsService,
        private library: FaIconLibrary,
        private containerService: ContainerService,
        private cd: ChangeDetectorRef,
        private toastr: ToastrService,
        protected override dialog: MatDialog,
        private translocoService: TranslocoService,
        private actionsSubj: ActionsSubject,
        private userService: UserService,
        private localStoreService: LocalStoreService,
        private accessService: AccessService,
        private appService: AppService,
        private sceneService: SceneService,
        private aiService: AiService,
        private paletteService: PaletteService,
        private router: Router,
        private injector: Injector
    ) {
        super();
        /* add support for free-regular-svg-icons so we can toggle style */
        this.setMe('scene-builder.component.ts');
        library.addIcons(faFloppyDisk, faSquare);

        // callback function when click "export" from professional backgroung dialog
        window['exportBg'] = (data) => {
            if (!data) return;

            this.toastr.info(this.translocoService.translate('toast.createBg', {}, this.translocoService.getActiveLang()), '', TOAST_FASTER);
            if (data.css) {
                this.importBackgroundImage(data.css);
            } else if (data.inline) {
                this.convertInlineSvg(data.inline);
            }
        };
    }

    @HostListener('window:keydown', ['$event'])
    keyDownEvent(event: KeyboardEvent) {
        if (this.textEditMode) return;
        if (!event.target) return;
        if (event.target['tagName'] == 'INPUT' || event.target['tagName'] == 'TEXTAREA') return;
        if (event.target['className'].includes("angular-editor")) {
            return;
        }

        if (event.shiftKey || event.ctrlKey || event.metaKey) {
            this.isMultiMode = true;
        } else {
            this.isMultiMode = false;
        }

        let preventDefault = false;

        switch (event.key) {
            case KEY_CODE.LEFT_ARROW:
            case KEY_CODE.UP_ARROW:
            case KEY_CODE.RIGHT_ARROW:
            case KEY_CODE.DOWN_ARROW: {    // move or resize items
                if (this.selectedItemIds && this.selectedItemIds.length > 0) {
                    preventDefault = true;
                    if (event.altKey) {
                        if (event.key == KEY_CODE.LEFT_ARROW || event.key == KEY_CODE.RIGHT_ARROW) {
                            // alt + arrow left(right) : item rotate 1 degrees by direction
                            // alt + ctrl + arrow left(right) : item rotate 45 degrees by direction
                            this.rotateItemsByKey(event.key, event.shiftKey);
                        } else {
                            // alt + arrow up : items push up,  alt + ctrl + arrow up : items push top.
                            // alt + arrow down : items push down,  alt + ctrl + arrow down : items push bottom.
                            this.changeItemOrdersByKey(event.key, event.shiftKey);
                        }
                    } else {
                        // arrow : move items by 1px,   shift + arrow : move items by 10px
                        // ctrl + arrow : resize items by 1px,    ctrl + shift + arrow : resize items by 10px
                        this.moveResizeItemsByKey(event.key, event.shiftKey, event.ctrlKey || event.metaKey);
                    }
                }
                break;
            }
            case KEY_CODE.X:
            case KEY_CODE.C:
            case KEY_CODE.V: {   // copy & cut & paste
                if (event.ctrlKey || event.metaKey) {
                    preventDefault = true;
                    this.cutCopyPasteByKey(event.key);
                }
                break;
            }
            case KEY_CODE.BRACKET_LEFT:      // ctrl + { : undo
            case KEY_CODE.BRACKET_RIGHT:     // ctrl + } : redo
            case KEY_CODE.Z:      // ctrl + Z : undo
            case KEY_CODE.Y: {    // ctrl + Y : redo
                if (event.ctrlKey || event.metaKey) {
                    preventDefault = true;
                    this.undoRedoByKey(event.key);
                }
                break;
            }
            case KEY_CODE.ESC: { // select scene background
                preventDefault = true;
                this.resetSelectable(true);
                break;
            }
            case KEY_CODE.B: {  // ctrl + b : select scene background
                if (event.ctrlKey || event.metaKey) {
                    preventDefault = true;
                    this.resetSelectable(true);
                }
                break;
            }
            case KEY_CODE.L: {  // ctrl + l : guideline show / hide
                if (event.ctrlKey || event.metaKey) {
                    preventDefault = true;
                    this.onClickSetGuidelines();
                }
                break;
            }
            case KEY_CODE.O:   // ctrl + o : orient horizontal, ctrl + alt + o : orient vertical,
            case KEY_CODE.OO: {
                if (event.ctrlKey || event.metaKey) {
                    preventDefault = true;
                    if (event.altKey) {
                        this.onClickOrientHorizontal();
                    } else {
                        this.onClickOrientVertical();
                    }
                }
                break;
            }
            case KEY_CODE.MINUS: {    // alt + - : zoom out
                if (event.altKey) {
                    preventDefault = true;
                    this.onClickZoomOut();
                }
                break;
            }
            case KEY_CODE.PLUS: {   // alt + + : zoom in
                if (event.altKey) {
                    preventDefault = true;
                    this.onClickZoomIn();
                }
                break;
            }
            case KEY_CODE.DEL: {     // delete : remove item or items
                preventDefault = true;
                this.removeSceneItems();
                break;
            }
            case KEY_CODE.S:   // ctrl + shift + s : show all hidden scene items
            case KEY_CODE.SS: {
                if ((event.ctrlKey || event.metaKey) && event.shiftKey) {
                    preventDefault = true;
                    this.onClickShowAll();
                } else if (event.altKey) {
                    preventDefault = true;
                    this.saveChanges(true);
                }
                break;
            }
            case KEY_CODE.H:   // ctrl + shift + h : hide selected items
            case KEY_CODE.HH: {
                if ((event.ctrlKey || event.metaKey) && event.shiftKey) {
                    preventDefault = true;
                    this.onClickHide();
                }
                break;
            }
            case KEY_CODE.T:
            case KEY_CODE.P:            case KEY_CODE.TT: {
                if (event.altKey) {
                    preventDefault = true;
                    this.addLabel();
                }
                break;
            }
            case KEY_CODE.HELP: {
                if ((event.ctrlKey || event.metaKey)) {
                    preventDefault = true;
                    this.onKeyboardHelp();
                }
                break;
            }
            default:
                break;
        }

        if (preventDefault) {
            event.preventDefault();
        }
    }

    @HostListener('window:keyup', ['$event'])
    keyUpEvent(event: KeyboardEvent) {
        this.isMultiMode = false;
    }

    @HostListener('wheel', ['$event'])
    onMouseWheel(event: WheelEvent) {
        // Only zoom when Ctrl key is pressed
        if (event.ctrlKey && this.isEditorFocus) {
            event.preventDefault();

            // deltaY < 0 means scrolling up (zoom in)
            // deltaY > 0 means scrolling down (zoom out)
            if (event.deltaY < 0) {
                this.onClickZoomIn();
            } else if (event.deltaY > 0) {
                this.onClickZoomOut();
            }
        }
    }

    ngOnInit(): void {
        this.cod(
            this.containerService.toolbarVisible.subscribe(visible => {
                this.toolbarHidden = !visible;
                this.cd.markForCheck();
            })
        );
        this.editorWidth = 1920;
        this.editorHeight = 1080;
        this.setValuesFromLocalstorage();
        this.setSaveMode();
        this.socialMediaSelection = new SelectionModel<string>(true, []);
        this.cod(
            this.actionsSubj.pipe(ofType(actionSocialPostSuccess))
                .subscribe((reply: any) => {
                    this.zone.run(() => {
                        reply.socialReply.forEach((i_socialReply) => {
                            if (i_socialReply.status === 'success') {
                                this.toastr.info('social posting completed for ' + i_socialReply.platform);
                            } else {
                                this.toastr.error('social failed for ' + i_socialReply.platform);
                            }
                        });
                        this.socialPosting = false;
                        this.cd.markForCheck();
                    });
                })
        );
        this.cod(
            this.storeSelector.getUser()
                .subscribe((i_user: IUser) => {
                    this.user = i_user;
                })
        );
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            })
        );
        this.cod(
            this.storeSelector.getLocalStoreUpdates('ILocalStorageConfig').pipe(filter((v) => v !== null))
                .subscribe((e) => {
                    this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon

                    const t = this.localStoreService.getStorageValConfig('sceneCheckeredBackground');
                    if (t === this.sceneCheckeredBackground) return;
                    this.sceneCheckeredBackground = t;
                    this.cd.markForCheck();
                })
        );
        this.cod(
            this.storeSelector.getPreviousLinkedScene().subscribe((i_previousLinkedSceneId) => {
                this.previousLinkedSceneId = i_previousLinkedSceneId;
            })
        );
        this.cod(
            this.storeSelector.getPreviousSlidesSceneId().subscribe((i_previousLinkedSliderId) => {
                this.previousSlidesSceneId = i_previousLinkedSliderId;
            })
        );
        this.cod(
            this.storeSelector.getSceneBreadcrumbs().subscribe((breadcrumbs) => {
                this.breadcrumbs = breadcrumbs || [];
                this.cd.markForCheck();
            })
        );
        this.cod(
            this.storeSelector.getOS().subscribe((i_os) => {
                this.iOS = i_os;
            })
        );
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
        this.cod(
            this.appService.getUploadingFiles().subscribe((v) => {
                if (!v || !v[0]) return;
                if (v[0].skipAutoBackground) return; // Skip auto-background if skipAutoBackground flag is set (for AI "add as resource")
                this.addResourceToScene(v[0])
                    .then(() => {
                        // Resource added successfully as background
                    })
                    .catch((error) => {
                        console.error('[scene-builder] Error adding resource to scene:', error);
                    });
            })
        );
        this.cod(
            this.accessService.getGroupsTable('SignStudio Editor', "player_data").subscribe((v) => {
                this.accessConfig = v;
            })
        );
        this.cod(
            this.accessService.getGroupsCollection("SignStudio Editor").pipe(map((value) => value)).subscribe((v) => {
                this.groupCollection = v;
            })
        );
        this.cod(
            this.storeSelector.getUndoable().subscribe((status: boolean) => {
                this.disableUndo = status;
            })
        );
        this.cod(
            this.storeSelector.getRedoable().subscribe((status: boolean) => {
                this.disableRedo = status;
            })
        );
        this.cod(
            this.storeSelector.listenDuplicateScene().subscribe((value: IUIDuplicationBlock) => {
                this.pasteData = value;
            })
        );
        this.cod(
            this.containerService.zoom.subscribe((zoomValue) => {
                // Only apply zoom changes from other instances in slide edit mode
                if (zoomValue && zoomValue !== this.zoom && this.slideEditMode) {
                    this.zoom = zoomValue;
                    this.zoomIndex = RULER_ZOOMS.indexOf(zoomValue);
                    this.changeWHofEditor();
                    this.localStoreService.setStorageValConfig('zoom', this.zoom);
                    this.cd.markForCheck();
                }
            })
        );
        this.cod(
            this.storeSelector.listenDuplicateSceneCommand().subscribe((value) => {
                if (value == 'COPY') {
                    this.isCopy = true;
                    this.isCut = false;
                } else if (value == 'CUT') {
                    this.isCopy = false;
                    this.isCut = true;
                } else {
                    this.isCut = false;
                    this.isCopy = false;
                }
            })
        );

        this.cod(
            this.storeSelector.getLockedRecords().subscribe((v: ILockedRecord) => {
                // this.lockedRecord = v;
                // this.checkLockedScene();
                this.lockedScene = checkLockedScene(v, this.selectedSceneId, this.studioId);
                this.cd.detectChanges();
            })
        );

        // this.cod(
        //     this.containerService.toggleGuideline.subscribe((v) => {
        //         this.isShowLines = !!v ? true : false;
        //         this.cd.detectChanges();
        //     })
        // );

        if (this.selectedSceneId === this.previousLinkedSceneId) {
            this.previousLinkedSceneId = null;
        }

        if (this.saveMode.saveSceneTimer) {
            this.cod(
                timer(SCENE_SAVING_INTERVAL, SCENE_SAVING_INTERVAL).subscribe(() => {
                    this.onSave(() => {
                    }, false);
                })
            );
        }

        this.cod(this.storeSelector.listenCRUDScene().subscribe(crudScene => {
            if (!crudScene) return;
            const cmd = crudScene.command;
            const disableSync = crudScene.disableSync;
            if (disableSync) return;

            if (['update', 'add', 'delete', 'reorder', 'rebuild'].indexOf(cmd) > -1) {

                if (this.lockedScene == 'locked') {
                    this.showLockModal((status) => {
                        if (status) {
                            this.appService.lockRecord(this.selectedSceneId);
                        } else {
                            this.onUndoRedo('UNDO', true);
                            this.storeSelector.dispatch({type: 'BREAK_MERGE'});
                        }
                    });
                } else {
                    this.appService.lockRecord(this.selectedSceneId);
                }
            }
        }));

        this.cod(
            this.containerService.getActiveSceneItemIds().subscribe((_ids) => {
                if (!_ids) {
                    setTimeout(() => {
                        this.storeSelector.dispatch(actionSelectedSceneItemId({id: this.selectedSceneId}));
                    });
                } else {
                    this.changeTargetById(_ids);
                }
            })
        );

        this.cod(
            this.subSelection.pipe(
                debounceTime(100)
            ).subscribe(event => {
                if (!event) return;
                if (event.selection) {
                    this.selectMoveableObjects(event.selection);
                } else if (event.layer) {
                    this.onPushLayers(event.layer);
                }
            })
        );
        this.cod(
            this.aiService.layerCommand$.subscribe(cmd => {
                this.onPushLayers(<any>cmd);
            })
        );
        this.cod(
            this.storeSelector.isFirefox().subscribe((v) => {
                this.isFirefox = v;
            })
        );

        this.cod(
            this.storeSelector.getSliderSelection().subscribe((sliderSelection) => {
                // Only process if this matches the current slider being edited
                if (this.slideEditMode) {
                    this.sliderSceneId = sliderSelection.sceneId;
                } else {
                    this.sliderSceneId = null;
                }
            }),
        );

        this.cod(
            this.aiService.sceneCommands$.subscribe( command => {
                switch (command) {
                    case 'SAVE':
                        this.saveChanges(true);
                        break;

                    case "PREVIEW":
                        this.showPreviewPopup();
                        break;

                    case "REGISTER":
                        this.showAddPlayerModal();
                        break;

                    case "COPY":
                        this.onClickCopy();
                        break;

                    case "PASTE":
                        this.onClickPaste();
                        break;

                    case 'UNDO':
                    case 'REDO':
                        this.onUndoRedo(command);
                        break;

                    case 'DELETE':
                        this.removeSceneItems();
                        break;
                }

            })
        );

        this.cod(
            this.aiService.backgroundResource$.subscribe( cmd => {
                this.convertToBackground();
            })
        );


        this.editorElement = document.querySelector(".editor");
        this.viewElement = document.querySelector(".view");
        this.pageElement = document.querySelector(".page");

        this.rulerMinHeight = document.body.clientHeight;
        this.rulerMinWidth = document.body.clientWidth;
        this.storeSelector.addedBlockCount = 0;
    }

    private setValuesFromLocalstorage() {
        this.showDirections = convertNumberToBoolean(this.localStoreService.getStorageValConfig('showDirections'));
        this.sceneCheckeredBackground = this.localStoreService.getStorageValConfig('sceneCheckeredBackground');
        this.studioId = this.localStoreService.getStorageValConfig('studioId');

        this.rememberSelection = convertNumberToBoolean(this.localStoreService.getStorageValConfig('rememberPreviewSettings'));
        if (this.rememberSelection) {
            this.previewMode = this.localStoreService.getStorageValConfig('previewMode') || 'size';
            this.previewSizeX = this.localStoreService.getStorageValConfig('previewSizeX');
            this.previewSizeY = this.localStoreService.getStorageValConfig('previewSizeY');
            this.previewPercent = parseInt(this.localStoreService.getStorageValConfig('previewPercent')) || 100;
            const storedPreviewSceneId = this.localStoreService.getStorageValConfig('previewSceneId');
            if (storedPreviewSceneId) {
                this.previewSceneId = storedPreviewSceneId;
            }
        }
    }

    updateGuideline() {
        this.resetGuideLines();
        this.guidelineOpacity = 1;

        let guide_data;
        try {
            guide_data = JSON.parse(this.localStoreService.getStorageValConfig("guidelines"));
        } catch (e) {
            Lib.DevShow('no guidelines...');
            return;
        }

        if (!guide_data || !guide_data[this.selectedSceneId]) {
            return;
        }
        const lines: IGuideLines = guide_data[this.selectedSceneId];

        if (lines) {
            if (lines.horizontal) {
                this.guidelines.horizontal = lines.horizontal.split(",").map((v) => Math.round(+v * this.editorHeight));
            }
            if (lines.vertical) {
                this.guidelines.vertical = lines.vertical.split(",").map((v) => Math.round(+v * this.editorWidth));
            }
            if (lines.opacity) {
                this.guidelineOpacity = +lines.opacity;
            }
            if (lines.hidden) {
                this.hidelines.horizontal = lines.hidden.horizontal;
                this.hidelines.vertical = lines.hidden.vertical;
            }
            this.isShowLines = !!lines.visible;
        }
    }

    saveChanges(i_manual) {
        this.onSave(() => {
            this.savedIcon = !this.savedIcon;
            this.storeSelector.dispatch(actionPlaySweepLine());
            this.openRecordForEdit();
        }, i_manual);
    }

    onSave(callback, isManual) {
        if (this.accessConfig?.upd === false) {
            this.accessService.showNoAccess();
            return;
        }
        if (this.lockedScene == 'locked') {
            if (isManual) {
                this.toastr.error(this.translocoService.translate('toast.lockedSave', {}, this.translocoService.getActiveLang()));
            }
            return;
        }
        // else if (!this.lockedScene) {
        //   return;
        // }

        this.storeSelector.getScene(this.selectedSceneId).pipe(take(1)).subscribe((scene: IPlayerProps) => {
            if (!scene) return;
            const lastModified = new Date().getTime();
            const saveRecord = preprocessSceneRecord(scene, this.selectedSceneId, this.localStoreService.getStorageConfig().studioId, 'update', lastModified);
            this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
                /** important dont update store since server command failed **/
                if (!i_crudReply.serverReply.status) {
                    this.toastr.error(this.translocoService.translate('toast.failedSave', {}, this.translocoService.getActiveLang()));
                } else {
                    if (isManual) {
                        this.toastr.info(this.translocoService.translate('toast.successSave', {}, this.translocoService.getActiveLang()), '', TOAST_FASTER);
                    }
                }
                if (!this.slideEditMode) {
                    this.sceneService.updateLastModified(this.selectedSceneId, lastModified);
                }
                callback();

                if (isManual && this.localStoreService.getStorageValConfig('restartPlayer') === '1') {
                    this.cod(
                        this.storeSelector.getStationsComplete(EnumConnectionType.CONNECTED)
                            .subscribe((v) => {
                                if (v.length === 0) return;
                                const selectionModel = new SelectionModel<IStationData>(true, v);
                                this.userService.sendStationCommand('syncAndStart', selectionModel, this.selectedSceneId);
                            })
                    );
                }
            });
        });
    }

    backSceneList() {
        // if (this.saveMode.saveSceneOnExit) {
        //     this.onSave(() => {}, false);
        // }
        if (this.slideEditMode) {
            this.containerService.setMarkedTableRow(this.sliderSceneId);
        } else {
            this.containerService.setMarkedTableRow(this.selectedSceneId);
        }
        this.router.navigateByUrl('/editor/list');
    }

    changeDetection(delay = false) {
        if (delay) {
            setTimeout(() => {
                this.cd.detectChanges();
            });
        } else {
            this.cd.detectChanges();
        }
    }

    onMouseOutView() {
        this.isMouseOut = true;
        this.containerService.isMouseOnScene.next(false);
    }

    onMouseOverView() {
        this.isMouseOut = false;
        this.containerService.isMouseOnScene.next(true);
    }

    // get mouse pointer coordinates
    onMouseMoveView(event) {
        this.isMouseOut = false;
        this.isMouseDragging = true;

        if (!this.viewElement || !this.pageElement) {
            this.mousePosition = [0, 0, 0, 0];
            return;
        }

        const viewBounds = this.viewElement.getBoundingClientRect();
        const pageBounds = this.pageElement.getBoundingClientRect();

        const x = Math.round((event.clientX - viewBounds.left) / this.zoom);
        const y = Math.round((event.clientY - viewBounds.top) / this.zoom);

        // (event.clientX - pageBounds.left): absolute position x not related to scroll
        // (event.clientY - pageBounds.top): absolute position y not related to scroll
        this.mousePosition = [x, y, event.clientX - pageBounds.left, event.clientY - pageBounds.top];
    }

    onMouseDownView(event) {
        this.isMouseDragging = false;
        this.isMouseDown = true;
        const editableLabel = event.target.classList.contains("editable-label");
        if (!this.textEditMode && !editableLabel) {
            event.preventDefault();
        }
    }

    onMouseUpView(event) {
        this.toggleTextArea(event);
        this.isMouseDragging = false;
        this.isMouseDown = false;
        // this.isDraggingItem = false;
    }

    onMouseDownMoveable(e) {
        // Alon svg ???
        if (String(e.target.className).indexOf("moveable-control") > -1) {
            e.stopPropagation();
        }
    }

    /** Scene Overlay mouse move events for scene dragging similar to Figma */
    onMouseDownOverlay(e) {
        if (!this.dragSceneEnabled) return;

        this.dragPos = {
            // The current scroll
            left: this.pageElement.scrollLeft,
            top: this.pageElement.scrollTop,
            // Get the current mouse position
            x: e.clientX,
            y: e.clientY,
        };
        this.draggingScene = true;
        e.target.style.cursor = 'grabbing';
        e.stopPropagation();
        this.cd.detectChanges();
    }

    onMouseMoveOverlay(e) {
        if (!this.draggingScene) return;

        // How far the mouse has been moved
        const dx = e.clientX - this.dragPos.x;
        const dy = e.clientY - this.dragPos.y;

        // Scroll the element
        this.pageElement.scrollTop = this.dragPos.top - dy;
        this.pageElement.scrollLeft = this.dragPos.left - dx;
    }

    onMouseUpOverlay(e) {
        this.draggingScene = false;
        e.target.style.cursor = 'grab';
        this.cd.detectChanges();
    }

    toggleDragScene() {
        this.dragSceneEnabled = !this.dragSceneEnabled;
        this.cd.detectChanges();
    }

    /**
     * Set editable/selectable scene-label textarea
     */
    private toggleTextArea(e) {
        const editableLabel = e.target.classList.contains("editable-label");
        if (editableLabel) {
            const targetId = e.target.parentElement.parentElement.id;
            let editable = false;

            // check first-click or second-click
            if (targetId == this.lastSelectedTargetId) {
                if (this.textEditMode || (this.isMouseDown && !this.isMouseDragging)) {
                    editable = true;
                }
            }

            const className = e.target.parentElement.parentElement.className;
            if (!className || className.indexOf("ds-selectable") === -1 || className.indexOf("scene-label") === -1) {
                editable = false;
            }

            // toggle textarea disabled
            if (editable) {
                this.textEditMode = true;
                e.target.focus();
            } else {
                e.target.blur();
                this.textEditMode = false;
                this.lastSelectedTargetId = targetId;
            }
            this.cd.detectChanges();
        } else {
            this.lastSelectedTargetId = -1;
            this.textEditMode = false;
        }
    }

    private convertLabelToEditable(itemId) {
        let sel, range;
        const el: any = document.querySelector(`#${itemId} .editable-label`);
        if (!el) {
            return;
        }
        if (window.getSelection && document.createRange) {
            range = document.createRange();
            range.selectNodeContents(el);
            sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            // @ts-expect-error: ignore compile error
        } else if (document.body.createTextRange) {
            // @ts-expect-error: ignore compile error
            range = document.body.createTextRange();
            range.moveToElementText(el);
            range.select();
        }
        this.textEditMode = true;
        this.lastSelectedTargetId = itemId;

        // the following code works, needs improvement to pull keyboard up in mobile
        /**
         el.focus();
         el.click();
         setTimeout(() => {
         jQuery('.editable-label').focus();
         }, 333);
         setTimeout(() => {
         jQuery('.editable-label').click();
         }, 3333);
         **/
    }

    showContextMenu(event = null, cx = null, cy = null) {
        let nestedSceneSrc = '';
        let resourceSrc = '';
        let itemId = '';
        let isRoot = false;
        this.enableBackground = false;

        if (event) {
            event.preventDefault();
            event.stopPropagation();
            const clickedItem = this.getClickedItem(event);
            if (!clickedItem.isSelected && clickedItem.moveableTarget) {
                this.drag.setSelection(clickedItem.moveableTarget, true);
                this.cd.detectChanges();

            } else if (!clickedItem.isSelected) {
                this.clearSelection();
            }

            if (!clickedItem.isGroup && clickedItem.moveableTarget) {
                itemId = clickedItem.moveableTarget.id;
            }
            isRoot = !clickedItem.moveableTarget;
        } else {
            isRoot = false;
            if (this.selectedItemIds.length === 1) {
                itemId = this.selectedItemIds[0];
            }
        }

        if (itemId) {
            nestedSceneSrc = this.sceneService.checkNestedSceneById(itemId);
            if (!nestedSceneSrc) {
                resourceSrc = this.checkIsResourceById(itemId);
            }
        }

        this.contextMenuPosition.x = `${event ? event.clientX : cx}px`;
        this.contextMenuPosition.y = `${event ? event.clientY : cy}px`;

        this.contextMenu.menuData = {
            item: {
                isRoot,
                id: itemId,
                nestedSceneSrc,
                resourceSrc
            }
        };
        this.contextMenu.menu.focusFirstItem('mouse');
        this.contextMenu.openMenu();
    }

    onRightClickScene(event) {
        this.clearSelection();
    }

    onDoubleClickSceneItem(event) {
        event.preventDefault();
        event.stopPropagation();

        let nestedSceneSrc = '';
        let itemId = '';
        this.enableBackground = false;

        const clickedItem = this.getClickedItem(event);

        if (!clickedItem.isGroup && clickedItem.moveableTarget) {
            itemId = clickedItem.moveableTarget.id;
            nestedSceneSrc = this.sceneService.checkNestedSceneById(itemId);
            this.linkToOtherScene(nestedSceneSrc);
        }
    }

    linkToOtherScene(src) {
        if (!src) return;

        if (this.slideEditMode) {
            this.storeSelector.dispatch(actionSceneJumpLinked({previousSlidesSceneId: this.sliderSceneId}));
            // Use service method to handle breadcrumb logic
            this.cod(
                this.storeSelector.getScene(this.sliderSceneId).pipe(take(1)).subscribe((_scene) => {
                    this.sceneService.handleSceneBreadcrumbs(
                        src,
                        this.sliderSceneId,
                        _scene.Player?.$?.label,
                        () => {
                            this.router.navigateByUrl(`/editor/scene/${src}`);
                        }
                    );
                })
            )
            
        } else {
            this.storeSelector.dispatch(actionSceneJumpLinked({previousLinkedSceneId: this.selectedSceneId}));
            // Use service method to handle breadcrumb logic
            this.sceneService.handleSceneBreadcrumbs(
                src,
                this.selectedSceneId,
                this.sceneData.Player?.$?.label,
                () => {
                    this.router.navigateByUrl(`/editor/scene/${src}`);
                }
            );
        }

    }

    navigateToBreadcrumb(index: number) {
        if (!this.breadcrumbs || index < 0 || index >= this.breadcrumbs.length) return;

        const targetBreadcrumb = this.breadcrumbs[index];
        if (!targetBreadcrumb || !targetBreadcrumb.sceneId) return;

        // Slice breadcrumbs to only include up to the clicked index
        const newBreadcrumbs = this.breadcrumbs.slice(0, index + 1);
        this.storeSelector.dispatch(actionSceneBreadcrumbsSet({ breadcrumbs: newBreadcrumbs }));

        // Navigate to the selected scene

        this.cod(
            this.storeSelector.getScene(targetBreadcrumb.sceneId).pipe(take(1)).subscribe((targetScene) => {
                if (!isMainTouchScene(targetScene)) {
                    this.storeSelector.dispatch(actionSelectedSceneId({ id: targetBreadcrumb.sceneId }));
                    this.router.navigateByUrl(`/editor/scene/${targetBreadcrumb.sceneId}`);
                } else {
                    const firstChildSceneId = TouchLib.getFirstSlideSceneId(targetScene);
                    this.storeSelector.dispatch(actionSelectedSceneId({ id: firstChildSceneId }));
                    this.storeSelector.dispatch(actionSelectedSceneTouchId(
                        TouchLib.createSelectedSliderPayload(
                            targetScene.Player.$.id,
                            targetScene.Player.$.label,
                            firstChildSceneId,
                        ),
                    ));
                    this.router.navigateByUrl(`/editor/touch/scene/${targetScene.Player.$.id}`);
                }
            })
        )
    }

    // icon click event: when user click ">" icon of toolbar
    onClickForward() {
        this.subSelection.next({
            layer: 'Up'
        });
    }

    // icon click event: when user click "<" icon of toolbar
    onClickBackward() {
        this.subSelection.next({
            layer: 'Down'
        });
    }

    // 1. icon click event: when user click "<>" icon (push to top)
    // 2. context menu click: when user click 'push to top' from right context menu.
    onClickPushToTop() {
        this.subSelection.next({
            layer: 'Top'
        });
    }

    // 1. icon click event: when user click "><" icon of toolbar (push to bottom)
    // 2. context menu click: when user click 'push to bottom' from right context menu.
    onClickPushToBottom() {
        this.subSelection.next({
            layer: 'Bottom'
        });
    }

    // 1. icon click event: when user click "Copy" icon of toolbar
    // 2. context menu click: when user click 'Copy' from right context menu.
    onClickCopy() {
        if (this.selectedItemIds.length == 0) {
            return;
        }
        this.getCopyCutSceneItems('COPY');
    }

    onClickPlayScene() {
        this.storeSelector.dispatch(actionCRUDScene({
            data: {
                command: 'play',
                sceneId: this.selectedSceneId,
                itemIds: this.selectedItemIds.length > 1 ? null : this.selectedItemIds
            }
        }));
    }

    createSharedUrl(): string {
        const sceneId = this.previewSceneId ?? this.selectedSceneId;
        return createScenePreviewUrl(this.coreAppData, null, sceneId, this.isFullFeatures);
    }

    showPreviewPopup() {
        if (this.groupCollection?.$?.preview === '0') {
            this.accessService.showNoAccess();
            return;
        }
        this.saveChanges(false);
        const dialogData: DialogPreviewData = {
            selectedSceneId: this.selectedSceneId,
            previewSceneId: this.previewSceneId,
            sceneData: this.sceneData,
            editorWidth: this.editorWidth,
            editorHeight: this.editorHeight,
            isMainScene: this.isMainScene,
            sceneMimeShort: this.sceneMimeShort,
            coreAppData: this.coreAppData,
            isFullFeatures: this.isFullFeatures
        };
        if (this.slideEditMode){
            this.playPreviewEvent.emit(dialogData);
            return;
        } else {
            const dialogRef = this.dialog.open(DialogPreviewComponent, {
                width: '600px',
                data: dialogData
            });
            dialogRef.afterClosed().subscribe((result) => {
                if (result?.action === 'register') {
                    this.showAddPlayerModal();
                }
            });
        }
    }

    onClickPlayPreview() {
        let w = 0, h = 0;
        if (this.previewMode === 'size') {
            w = parseInt(this.previewSizeX);
            h = parseInt(this.previewSizeY);
        } else {
            w = Math.round(this.editorWidth * this.previewPercent / 100);
            h = Math.round(this.editorHeight * this.previewPercent / 100);
        }
        if (!w || !h) {
            return;
        }
        popupWindow({url: this.createSharedUrl(), title: '_blank', w, h}, 'yes', 'yes');
        this.dialog.closeAll();
    }

    openPaletteSelector() {
        const dialogRef = this.dialog.open(DialogPaletteSelectorComponent, {
            width: '90vw',
            height: '85vh',
            maxWidth: '1400px',
            data: {}
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result?.palette) {
                this.applyPaletteToScene(result.palette);
                this.toastr.success(
                    this.translocoService.translate('ai.applyPalette', {}, this.translocoService.getActiveLang()) + ': ' + result.palette.name,
                    '',
                    TOAST_FASTER
                );
            }
        });
    }

    /**
     * Apply selected color palette to all components in the current scene
     * Uses centralized PaletteService for all palette logic
     * @param palette - The selected color palette
     */
    private applyPaletteToScene(palette: ColorPalette) {
        if (!palette || !this.players || this.players.length === 0) {
            return;
        }

        // Apply palette background color to scene
        if (palette.pageBackground) {
            const colorDecimal = Lib.HexToDecimal(palette.pageBackground);
            this.sceneService.setSceneBackgroundColor(colorDecimal, true);
        }

        // Use centralized service to apply palette to both labels AND buttons
        const updatedItems = this.paletteService.applyPaletteToScene(palette, this.players, this.selectedSceneId);

        // Dispatch all updates to the store
        if (updatedItems.length > 0) {
            this.storeSelector.dispatch(actionUpdateSceneItemGroup({items: updatedItems}));
        } else {
            this.toastr.info(
                this.translocoService.translate('ai.noComponentsFound', {}, this.translocoService.getActiveLang()),
                '',
                TOAST_FASTER
            );
        }
    }

    // 1. icon click event: when user click "Cut" icon of toolbar
    // 2. context menu click: when user click 'Cut' from right context menu.
    onClickCut() {
        if (this.selectedItemIds.length == 0) {
            return;
        }
        this.getCopyCutSceneItems('CUT');
    }

    // 1. icon click event: when user click "Paste" icon of toolbar
    // 2. context menu click: when user click 'Paste' from right context menu.
    onClickPaste(isButton: boolean = false) {
        if (!this.isCut && !this.isCopy) {
            return;
        }
        if (isButton) {
            this.pasteSceneItems([0, 0]);
            this.clearSelection();
        } else {
            this.pasteSceneItems(this.mousePosition);
        }
        this.isCut = false;
    }

    duplicate(itemIds = null) {
        if (!itemIds) {
            itemIds = this.selectedItemIds;
        }
        if (!itemIds) return;

        const selectedPlayers = this.players.filter((p) => !!itemIds.find((_id) => compareIds(_id, p.$.id)));
        const addedItemIds = [];
        const values = [];

        selectedPlayers.forEach((block) => {
            // get block label and template from scene tree
            const blockLabelProps: IBlockLabelProp = this.storeSelector.getBlockLabelById(block.$.player);

            const tmpBlockData: ISceneBlock = _.cloneDeep(block);
            tmpBlockData.$.id = _.uniqueId('__');

            addedItemIds.push(tmpBlockData.$.id);
            tmpBlockData.Data[0].Layout[0].$.x = +tmpBlockData.Data[0].Layout[0].$.x + (this.pasteCount * 20) + '';
            tmpBlockData.Data[0].Layout[0].$.y = +tmpBlockData.Data[0].Layout[0].$.y + (this.pasteCount * 20) + '';

            // value list to dispatch 'actionAddSceneItem'
            values.push({
                key: 'Player',
                cloneValue: false,
                value: tmpBlockData,
                storePath: 'Data["0"].Scene["0"].Players[0]'
            });
        });

        if (values.length === 0) {
            return;
        }
        this.pasteCount = this.pasteCount % 5 + 1;

        this.storeSelector.dispatch(actionAddSceneItem({
            sceneId: this.selectedSceneId,
            sceneItemId: this.selectedSceneId,
            updatedItemIds: addedItemIds,
            values
        }));
    }

    // icon click event: when user click "Remove Guidelines" icon of toolbar
    onClickSetGuidelines() {
        this.dialogRef = this.dialog.open(this.guidelineModal);
    }

    // click remove icon from guideline modal
    onClickRemoveGuidelines() {
        this.isShowLines = false;
        this.guidelineOpacity = 1;
        this.resetGuideLines();
        this.changeGuidelines();
        this.dialogRef.close();
    }

    // icon click event: when user click "Resolution" icon of toolbar
    onClickResolution() {
        const res = [1, 5, 10, 20, 50];
        this.resolution = res[(res.indexOf(this.resolution) + 1) % 5];
    }

    onClickChangeMagnetic() {
        this.showDirections = !this.showDirections;
        this.localStoreService.setStorageValConfig('showDirections', this.showDirections);
    }

    // icon click event: when user click "zoom-in" icon of toolbar
    onClickZoomIn() {
        if (this.zoomIndex > 0) {
            this.zoomIndex -= 1;
            this.changeSceneByZoom();
        }
    }

    // icon click event: when user click "zoom-out" icon of toolbar
    onClickZoomOut() {
        if (this.zoomIndex < this.zoom_cnt - 1) {
            this.zoomIndex += 1;
            this.changeSceneByZoom();
        }
    }

    // icon click event: when click "zoom back"
    onClickZoomBack() {
        this.zoomIndex = RULER_ZOOMS.indexOf(1);
        this.changeSceneByZoom();
    }

    // icon click event: when user click "orient horizontal" icon of toolbar
    onClickOrientHorizontal() {
        this.orientSceneItems(true);
    }

    // icon click event: when user click "orient vertical" icon of toolbar
    onClickOrientVertical() {
        this.orientSceneItems(false);
    }

    onUndoRedo(actionType: 'UNDO' | 'REDO', disableSync = null) {
        if (!actionType) return;

        const sceneItemId = this.selectedSceneItemId;
        this.clearSelection();

        this.storeSelector.dispatch({type: actionType});
        this.storeSelector.dispatch(actionCRUDScene({
            data: {
                command: 'rebuild',
                sceneId: this.selectedSceneId,
                itemIds: [],
                disableSync: disableSync
            }
        }));

        setTimeout(() => {
            if (sceneItemId) {
                this.containerService.activeSceneItemIds.next([sceneItemId]);
                this.storeSelector.dispatch(actionSelectedSceneItemId({id: sceneItemId}));
            }
        }, 100);
    }

    onSceneLoaded(event) {
        if (!event) return;

        if (event.created) {
            this.moveElements = document.querySelectorAll('#viewSceneContainer .moveable');
            this.drag = new DragSelect({
                selectables: this.moveElements,
                area: document.querySelector("#viewSceneContainer"),
                // autoScrollSpeed: 15,
                // selectableClass: 'moveable',
                // zoom: 2,
                zoom: this.zoom,
                // onDragStartBegin: (e) => this.onDragStart(e),
                onDragStart: (e) => this.onDragStart(e),
                callback: (e) => this.dragCallback(e),
                onElementSelect: (e) => this.onSelectElement(e),
                onElementUnselect: (e) => this.onUnselectElement(e)
            });
            const z = this.localStoreService.getStorageValConfig('zoom');
            if (z) {
                this.changeSceneByZoom(+z);
            }
        } else if (event.updated) {
            this.resetSelectable();
        }
    }

    /**
     * DragSelect a callbacks event: Fired when the selection starts (i.e. on mouse-down).
     */
    private onDragStart(e) {
        if (this.isMultiMode || this.selectedByTree || !e.target) return;

        const selection = this.getClickedItem(e);

        if (selection.isSelected || selection.isMoveableControl) {
            this.drag.break();
            if (selection.isSelected) {
                return;
            }
        }
        // this.isDraggingItem = true;
    }

    /**
     * DragSelect a callbacks event: Fired after the selection (i.e. on mouse-up).
     */
    private dragCallback(event) {
        this.subSelection.next({
            'selection': event
        });
    }

    /**
     * Create selected item index and id list, update selection
     */
    private selectMoveableObjects(event, fromTree = false) {
        // this.isLocked = false;
        if (this.accessConfig?.upd === false) {
            return;
        }
        if (!event) return;
        this.selectedIndexList = [];
        this.selectedItemIds = [];

        event.forEach((ele) => {
            this.selectedItemIds.push(ele.id);
            this.selectedIndexList.push(this.sceneItems.findIndex((i_item) => i_item.id == ele.id));
        });

        if (this.selectedItemIds.length == 1) {
            this.checkIsResourceById(event[0].id);
        }

        if (!fromTree) {
            if (this.selectedItemIds.length == 1) {
                this.storeSelector.dispatch(actionSelectedSceneItemId({id: event[0].id}));
            } else {
                this.storeSelector.dispatch(actionSelectedSceneItemId({id: this.selectedSceneId}));
            }

            // this.isDraggingItem = false;
            if (this.selectedItemIds.length > 0) {
                this.containerService.activeSceneItemIds.next(this.selectedItemIds);
            } else {
                this.containerService.activeSceneItemIds.next([this.selectedSceneId]);
            }
        }
        this.resetTargetSelection();
        this.pasteCount = 1;
    }

    /**
     * DragSelect a callbacks event: Fired when an element is added to the selection.
     */
    private onSelectElement(e) {
        if (this.isMultiMode || this.selectedByTree) return;

        // if (this.isDraggingItem && this.drag) {
        //     this.drag.break();
        //     return;
        // }

        const diff = 5; // mouse pixel offset when click
        const initPosition = this.drag.getInitialCursorPosition();
        const currPosition = this.drag.getCurrentCursorPosition();

        if (Math.abs(initPosition.x - currPosition.x) < diff && Math.abs(initPosition.y - currPosition.y) < diff) {
            if (this.preSelectedItem) {
                this.drag.removeSelection(this.preSelectedItem, true);
            }
            this.preSelectedItem = this.drag.getSelection();
        }
    }

    /**
     * DragSelect a callbacks event: Fired when an element is removed from the selection.
     */
    private onUnselectElement(e) {
        if (this.isMultiMode || this.selectedByTree) return;
        this.preSelectedItem = [];
    }

    // emit function: call when user add/change guidelines, hidelines
    changeGuidelines() {
        // this.storeSelector.dispatch(actionSelectedSceneItemId({id: this.selectedSceneId}));
        let guide_data;
        try {
            guide_data = JSON.parse(this.localStoreService.getStorageValConfig("guidelines"));
        } catch (e) {
            Lib.DevShow('no guidelines...');
        }

        if (!guide_data) guide_data = {};

        guide_data[this.selectedSceneId] = {
            horizontal: this.guidelines.horizontal.map((v) => this.roundLinePercent(v / this.editorHeight)).join(),
            vertical: this.guidelines.vertical.map((v) => this.roundLinePercent(v / this.editorWidth)).join(),
            opacity: this.guidelineOpacity + '',
            hidden: this.hidelines,
            visible: this.isShowLines
        };
        this.localStoreService.setStorageValConfig('guidelines', JSON.stringify(guide_data));
        this.cd.detectChanges();
    }

    // emit function: call when move(drag, resize, rotate...) are finished.
    onUpdateSceneItems(event) {
        if (!event.targets || event.targets.length == 0) {
            return;
        }

        const itemGroup = [];
        event.targets.forEach((ele) => {

            // get transform - transition x, y value
            let dx = 0;
            let dy = 0;
            if (event.group == true && event.isRotated == true) {
                const ts = new WebKitCSSMatrix(ele.style.webkitTransform);
                dx = Math.round(ts.m41);
                dy = Math.round(ts.m42);
                // ele.style.removeProperty("transform");
            }

            // get transform - rotate angle
            let rotation = 0;
            const tr = ele.style.getPropertyValue("-webkit-transform");
            if (tr !== "none" && tr.indexOf("rotate") > -1) {
                // tslint:disable-next-line:radix
                const ang = parseInt((/rotate\((.+)deg\)/i.exec(tr))[1]);
                rotation = (ang % 360 + 360) % 360;
            }

            // if (ele.style.transform) {
            //   ele.style.removeProperty("transform");
            // }

            const w = +ele.style.width.slice(0, -2);
            const h = +ele.style.height.slice(0, -2);
            const xx = (+ele.style.left.slice(0, -2) + dx);
            const yy = (+ele.style.top.slice(0, -2) + dy);
            // const w = +ele.style.width.slice(0, -2) / this.zoom;
            // const h = +ele.style.height.slice(0, -2) / this.zoom;
            // const xx = (+ele.style.left.slice(0, -2) + dx) / this.zoom;
            // const yy = (+ele.style.top.slice(0, -2) + dy) / this.zoom;

            // get updated scene item data
            itemGroup.push(this.getPlayerUpdateData(ele.id, [
                {key: 'rotation', value: rotation + ''},
                {key: 'width', value: w + ''},
                {key: 'height', value: h + ''},
                {key: 'x', value: xx + ''},
                {key: 'y', value: yy + ''}
            ]));
        });

        // store dispatch with updated scene item data
        this.storeSelector.dispatch(actionUpdateSceneItemGroup({items: itemGroup, disableCRUD: false}));
        // this.isDraggingItem = false;
    }

    /**
     * 1. context menu click: when user click 'remove' from right click menu.
     * 2. icon click event: when user click 'trash' icon of toolbar
     * 3. remove scene items by provided ids
     */
    removeSceneItems(ids: Array<Id> = null) {
        if (!ids && this.selectedItemIds.length == 0) {
            return;
        } else if (!ids) {
            ids = this.selectedItemIds;
        }

        if (this.slideEditMode) {
            const protectedIds = [];
            const allowedIds = [];

            ids.forEach(itemId => {
                const player = this.players.find((_player) => _player.$.id == itemId);
                if (player) {
                    const blockID = player.$.player;
                    if (blockID === '4100' || blockID === '4102') {
                        protectedIds.push(itemId);
                    } else {
                        allowedIds.push(itemId);
                    }
                } else {
                    allowedIds.push(itemId);
                }
            });

            if (protectedIds.length > 0) {
                const blockNames = protectedIds.map(itemId => {
                    const player = this.players.find((_player) => _player.$.id == itemId);
                    return player?.$.player === '4100' ? 'Collection' : 'Playlist';
                }).join(', ');

                this.toastr.warning(
                    this.translocoService.translate('ai.cannotDeleteInSlideMode', {}, this.translocoService.getActiveLang()) + ': ' + blockNames,
                    this.translocoService.translate('ai.protectedBlocks', {}, this.translocoService.getActiveLang())
                );
            }

            if (allowedIds.length === 0) {
                return;
            }

            ids = allowedIds;
        }
        this.sceneService.removeSceneItems(ids, false);
        this.resetSelectable(true);
    }

    // 1. context menu click: when user click 'lock-unlock' from right click menu.
    // 2. icon click event: when user click 'lock' icon of toolbar
    onClickLock() {
        if (this.selectedItemIds.length == 0) {
            return;
        }
        const itemGroup = this.selectedItemIds.map((_id) => (
            this.getPlayerUpdateData(_id, [{key: 'locked', value: "true"}])
        ));

        // store dispatch with updated scene item data
        this.clearSelection();
        this.storeSelector.dispatch(actionUpdateSceneItemGroup({items: itemGroup}));
    }

    onClickUnlockAll() {
        if (!this.sceneItems) return;
        const msg = this.translocoService.translate('message.unlockAllv2', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '333px',
            width: '400px',
            data: {name: msg, showCancel: true}
        });

        const bgId = this.sceneService.getBackgroundImageId();

        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                const updatedDataGroup = this.sceneItems.filter((_item) => _item.locked == 'true' && _item.id != bgId).map((_item) => {
                    return this.getPlayerUpdateData(_item.id, [{key: 'locked', value: "false"}]);
                });
                // store dispatch with updated scene item data
                this.storeSelector.dispatch(actionUpdateSceneItemGroup({items: updatedDataGroup}));
                this.clearSelection();
            }
        });
    }

    // 1. context menu click: when user click 'lock-unlock' from right click menu.
    // 2. icon click event: when user click 'lock' icon of toolbar
    onClickHide() {
        if (this.selectedItemIds.length == 0) {
            return;
        }

        const updatedDataGroup = this.selectedItemIds.map((_id) => (
            this.getPlayerUpdateData(_id, [{key: 'invisible', value: "true"}])
        ));

        // store dispatch with updated scene item data
        this.clearSelection();
        this.storeSelector.dispatch(actionUpdateSceneItemGroup({items: updatedDataGroup}));
    }

    onClickShowAll() {
        if (!this.sceneItems) return;

        const msg = this.translocoService.translate('message.showAll', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '333px',
            width: '400px',
            data: {name: msg, showCancel: true}
        });

        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                const updatedDataGroup = this.sceneItems.filter((_item) => _item.invisible == 'true').map((_item) => {
                    return this.getPlayerUpdateData(_item.id, [{key: 'invisible', value: "false"}]);
                });
                // store dispatch with updated scene item data
                this.storeSelector.dispatch(actionUpdateSceneItemGroup({items: updatedDataGroup}));
                this.clearSelection();
            }
        });
    }

    private addLabel() {
        let pos;
        if (!this.labelCount) this.labelCount = 0;
        if (this.isMouseOut) {
            pos = [
                this.editorWidth / 2 + 10 * this.labelCount,  // x
                this.editorHeight / 2 + 10 * this.labelCount  // y
            ];
        }

        const labelComponent = this.storeSelector.blockLabels.LABEL;
        const blockData: ISceneBlock = _.cloneDeep(labelComponent.template);

        // Apply palette color if one is selected
        if (this.paletteService.hasPalette() && blockData?.Data?.[0]?.Label && blockData?.Data?.[0]?.Label?.[0]) {
            const paletteColor = this.paletteService.getCurrentColorDecimal('primaryAccent');
            if (paletteColor) {
                blockData.Data[0].Label[0].Font[0].$.fontColor = paletteColor;
            }
        }

        this.addSceneItemByDrag({
            block: blockData
        }, pos);
        this.labelCount += 1;
    }

    onClickPlay() {
        this.storeSelector.dispatch(actionCRUDScene({
            data: {
                command: 'play',
                sceneId: this.selectedSceneId,
                itemIds: this.selectedItemIds.length > 1 ? null : this.selectedItemIds
            }
        }));
    }

    onClickStop() {
        this.storeSelector.dispatch(actionCRUDScene({
            data: {
                command: 'stop',
                sceneId: this.selectedSceneId,
                itemIds: this.selectedItemIds.length > 1 ? null : this.selectedItemIds
            }
        }));
    }

    // click event of guide line template images
    onClickLineImage(type: number) {
        if (!this.isShowLines) {
            return;
        }
        const w = this.editorWidth;
        const h = this.editorHeight;
        this.resetGuideLines();

        const guides = getGuidelineFromPattern(type, w, h);
        this.guidelines = guides.guidelines;
        this.hidelines = guides.hidelines;

        this.changeGuidelines();
        this.dialogRef.close();
    }

    /** toolbar Align event */
    onClickAlign(type) {
        if (this.selectedItemIds.length == 0) {
            return;
        }
        const xy = this.getTopLeftCoordinate();
        const wh = this.getWidthHeightArea();

        let dx = xy[0];
        let dy = xy[1];
        const dw = wh[0];
        const dh = wh[1];

        switch (type) {
            case 'top':
                dx = 0;
                dy = -1 * dy;
                break;
            case 'middle':
                dx = 0;
                dy = (this.editorHeight - dh) / 2 - dy;
                break;
            case 'bottom':
                dx = 0;
                dy = this.editorHeight - dh - dy;
                break;
            case 'left':
                dx = -1 * dx;
                dy = 0;
                break;
            case 'center':
                dx = (this.editorWidth - dw) / 2 - dx;
                dy = 0;
                break;
            case 'right':
                dx = this.editorWidth - dw - dx;
                dy = 0;
                break;
        }

        const itemGroup = this.selectedIndexList.map((idx) => {
            const item = this.sceneItems[idx];
            const x0 = +item.x;
            const y0 = +item.y;

            // get updated scene item data
            return this.getPlayerUpdateData(this.sceneItems[idx].id, [
                {key: 'x', value: x0 + dx + ''},
                {key: 'y', value: y0 + dy + ''}
            ]);
        });

        // store dispatch with updated scene item data
        this.storeSelector.dispatch(actionUpdateSceneItemGroup({items: itemGroup}));
    }

    backScene() {
        // If there are breadcrumbs, navigate to the previous breadcrumb scene
        if (this.breadcrumbs && this.breadcrumbs.length > 1) {
            // Navigate to the second-to-last breadcrumb (previous scene)
            this.navigateToBreadcrumb(this.breadcrumbs.length - 2);
        } else {
            // No breadcrumbs or only one, go back to scene list
            this.backSceneList();
        }
    }

    onKeyboardHelp() {
        this.dialog.open(DialogHotkeysComponent, {
            width: '450px',
            data: {
                mode: 'scene'
            }
        });
    }

    popupBackgroundWnd() {
        const url = `assets/background/index.html`;
        popupWindow({url, title: '_blank', w: 1200, h: 600}, 'no', 'yes');
    }

    private convertInlineSvg(inlineSvg) {
        const onTempImageLoad = (e) => {
            ctx.drawImage(e.target, 0, 0, canvas.width, canvas.height);
            const w = e.target.width;
            const h = e.target.height;

            canvas.toBlob((blob) => {
                this.uploadBackgroundImage(blob, w, h);
            });
        };

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = this.editorWidth;
        canvas.height = this.editorHeight;

        const tempImg = document.createElement('img');
        tempImg.addEventListener('load', onTempImageLoad);
        tempImg['src'] = 'data:image/svg+xml,' + encodeURIComponent(inlineSvg);
        // tempImg.src = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><foreignObject width="100%" height="100%"><div xmlns="http://www.w3.org/1999/xhtml"><div style="width: 800px; height: 700px;" id="aaaaaa"> <div id="newBackground"></div>  </div></div></foreignObject></svg>');
    }

    private uploadBackgroundImage(blob, width, height) {
        const fileName = `bg_${new Date().getTime()}.png`;
        const bgFile = new File([blob], fileName);

        const fileObj: FileObj = {
            fileName,
            fileType: fileName.split('.').pop(),
            file: bgFile,
            fileId: fileName,
            progress: 0,
            uploadStatus: UploadStatus.READY,
            formattedSize: formatBytes(bgFile.size, 2),
            fileSize: bgFile.size,
            width,
            height
        };

        this.appService.setUploadingFiles([fileObj]);
        this.appService.setUploadingStatus({
            process: 0,
            show: false
        });

        setTimeout(() => {
            this.appService.uploadResourceFiles();
        });

        this.dialog.open(DialogImportingComponent, {
            height: '400px',
            width: '400px',
            panelClass: 'transparentDialog',
            data: {
                showCancel: true
            },
            disableClose: true
        });
    }

    private importBackgroundImage(css) {
        // if (!css) return;
        this.zone.runOutsideAngular(() => {
            const element: HTMLElement = document.getElementById("newBackground");
            element.setAttribute("style", `${css}; width: ${this.editorWidth}px; height: ${this.editorHeight}px;`);

            html2canvas(element).then((canvas) => {
                canvas.toBlob((blob) => {
                    // const link = document.createElement("a");
                    // link.download = "background.png";
                    // link.href = URL.createObjectURL(blob);
                    // link.click();
                    // return;

                    this.uploadBackgroundImage(blob, this.editorWidth, this.editorHeight);
                }, 'image/png');
            });
        });
    }

    private async addResourceToScene(fileObj) {
        try {
            if (fileObj.uploadStatus == UploadStatus.SUCCESS) {
                if (SUPPORTED_FILE_TYPES.indexOf(fileObj.fileType.toLowerCase()) === -1) {
                    return;
                };

                const updatedRes: IResourceUpload = {
                    resource_name: fileObj.fileName.split('.').slice(0, -1).join('.'),
                    default_player: this.storeSelector.getBlockLabelByFileType(fileObj.fileType.toLowerCase()).id as any,
                    resource_type: fileObj.fileType,
                    resource_date_created: `${new Date().getTime()}`,
                    resource_date_modified: `${new Date().getTime()}`,
                    resource_bytes_total: `${fileObj.fileSize}`,
                    resource_pixel_height: `${this.editorHeight}`,
                    resource_pixel_width: `${this.editorWidth}`,
                    access_key: '0',
                };

                /** update resource of table */
                const saveRecord: ICRUDRecord = {
                    studioId: this.localStoreService.getStorageConfig().studioId,
                    command: 'update',
                    primary: 'resource_id',
                    table: 'resources',
                    body: updatedRes,
                    id: fileObj.fileId
                };

                // this.storeSelector.dispatch(actionCRUDRecord({saveRecord}));
                fileObj.uploadStatus = UploadStatus.UPDATING;

                const crudReply: ICRUDRecord = await this.appService.crudRecord(saveRecord);

                /** important don't update store since server command failed **/
                if (!crudReply.serverReply.status) return;

                /** add new resource in store */
                updatedRes['resource_id'] = String(fileObj.fileId);
                updatedRes['id'] = String(fileObj.fileId);
                updatedRes['changelist_id'] = String(crudReply.serverReply.changelist_id);

                this.storeSelector.dispatch(actionAddResources({data: updatedRes as IResource}));

                this.sceneService.setBackgroundImage({
                    resId: updatedRes['id'],
                    resType: 'png',
                    showConfirmDialog: false
                });

                setTimeout(() => {
                    this.cd.detectChanges();
                    this.dialog.closeAll();
                }, IMPORT_WAIT_SECONDS);
            }

        } catch (ex) {
            this.toastr.info(this.translocoService.translate('toast.generalFailure2', {}, this.translocoService.getActiveLang()));
        }

        setTimeout(() => {
            this.appService.setUploadingFiles([]);
        }, 5000);
    }

    private processScenePlayers(i_scenePlayer) {
        if (!i_scenePlayer) {
            return;
        }

        this.sceneMimeType = this.sceneData.Player.$.mimeType;
        this.isMainScene = this.storeSelector.isMainSceneOrPlayer(this.sceneMimeType);
        this.sceneMimeShort = mimeSwap("longToShort", this.sceneMimeType);

        this.players = _.cloneDeep(i_scenePlayer?.Player.Data["0"].Scene["0"].Players["0"].Player);
        if (!this.players) {
            this.players = [];
        }

        this.sceneItems = [];
        let ind = 0;

        this.players.forEach((i_item: ISceneBlock) => {
            if (!isSceneButNotSubScene(i_item)) {
                if (sceneItemInvalid(i_item)) return;
                const layout = i_item.Data[0].Layout[0].$;
                this.sceneItems.push({
                    x: layout.x,
                    y: layout.y,
                    width: layout.width,
                    height: layout.height,
                    rotation: layout.rotation,
                    id: i_item.$.id,
                    locked: layout.locked,
                    invisible: layout.invisible,
                    order: ind
                });
                ind++;
            }
        });
        this.resetSelectedIndex();
        this.isOrdering = false;
    }

    private setSaveMode() {
        if (this.localStoreService.getStorageValConfig('saveSceneTimer') == '1') {
            this.saveMode.saveSceneTimer = true;
        }
        if (this.localStoreService.getStorageValConfig('saveSceneManual') == '1') {
            this.saveMode.saveSceneManual = true;
        }
    }

    // change item orders by arrow up (down) key.
    private changeItemOrdersByKey(keyCode, isShift = false) {
        if (keyCode == KEY_CODE.DOWN_ARROW) {
            if (isShift) {
                this.onClickPushToBottom();
            } else {
                this.onClickBackward();
            }
        }
        if (keyCode == KEY_CODE.UP_ARROW) {
            if (isShift) {
                this.onClickPushToTop();
            } else {
                this.onClickForward();
            }
        }
    }

    // change scene items property and editor size
    private changeSceneByZoom(z = null) {
        if (z) {
            this.zoom = z;
            this.zoomIndex = RULER_ZOOMS.indexOf(z);
        } else {
            this.zoom = RULER_ZOOMS[this.zoomIndex];
        }

        this.changeWHofEditor();
        this.containerService.updateZoom(this.zoom);
        this.localStoreService.setStorageValConfig('zoom', this.zoom);
        // this.clearSelection();
        return;

        /** not used for now, but don't remove */
        // if (this.drag) {
        //     const selectedObjs = this.drag.getSelection();
        //
        //     this.drag.stop();
        //     document.querySelectorAll(".ds-selector").forEach((e) => e.remove());
        //     this.onSceneLoaded({created: true});
        //     // this.drag.start();
        //
        //     // reset selection after zoom
        //     this.drag.setSelection(selectedObjs, false);
        //     this.containerService.updateResetMoveable(true);
        // }
    }

    // select a moveable target by scene item index
    private changeTargetById(ids: Array<Id>) {
        if (!this.drag) return;

        let ele = [];
        this.selectedByTree = true;

        if (ids && this.selectedSceneId == ids[0]) {
            // if (this.isDraggingItem) return;
            this.drag.setSelection(ele);
        } else {
            if (ids.length == 1 && this.selectedItemIds.length == 1 && this.selectedItemIds[0] == ids[0]) {
                this.selectedByTree = false;
                return;
            }

            if (this.moveElements && this.moveElements.length > 0) {
                ele = Array.from(this.moveElements).filter((i_ele) => ids.indexOf(i_ele['id']) > -1);
                this.drag.setSelection(ele);
            }
        }

        this.selectMoveableObjects(ele, true);
        setTimeout(() => {
            this.selectedByTree = false;
            // this.isDraggingItem = false;
        }, 100);
    }

    private onPushLayers(layer: 'Up' | 'Down' | 'Top' | 'Bottom', isForce = false) {
        if (this.isOrdering || this.selectedItemIds.length == 0 || this.selectedItemIds.length == this.sceneItems.length) {
            return;
        }

        this.isOrdering = true;

        // get current indexes of selected players
        const oldIndexes = [];
        let newIndexes = [];

        for (const _id of this.selectedItemIds) {
            const playerIndex = this.players.findIndex((_player) => compareIds(_player.$.id, _id));
            if (playerIndex == -1) continue;
            oldIndexes.push(playerIndex);
        }

        // sort current indexes
        if (layer == 'Up') {
            oldIndexes.sort((a, b) => b - a);
        } else if (layer == 'Down') {
            oldIndexes.sort((a, b) => a - b);
        }

        const maxIndex = this.players.length;
        const minIndex = !isForce && this.sceneService.getBackgroundImageId() ? 1 : 0;

        // get new player indexes after changed layer
        switch (layer) {
            case 'Up': {
                oldIndexes.forEach((ind) => {
                    if (ind + 1 >= maxIndex || newIndexes.indexOf(ind + 1) > -1) {
                        newIndexes.push(ind);
                    } else {
                        newIndexes.push(ind + 1);
                    }
                });
                break;
            }
            case 'Down': {
                oldIndexes.forEach((ind) => {
                    if (ind - 1 < minIndex || newIndexes.indexOf(ind - 1) > -1) {
                        newIndexes.push(ind);
                    } else {
                        newIndexes.push(ind - 1);
                    }
                });
                break;
            }
            case 'Top': {
                newIndexes = oldIndexes.map((_ind, i) => maxIndex - i);
                break;
            }
            case 'Bottom': {
                newIndexes = oldIndexes.map((_ind, i) => i + minIndex);
                break;
            }
        }

        oldIndexes.sort((a, b) => a - b);
        newIndexes.sort((a, b) => a - b);

        const newPlayers = this.players.filter((_p, ind) => oldIndexes.indexOf(ind) == -1);
        newIndexes.forEach((ind, i) => {
            newPlayers.splice(ind, 0, this.players[oldIndexes[i]]);
        });

        // update store
        this.updateScenePlayers(newPlayers);

        // setTimeout(() => {
        //     this.isOrdering = false;
        // }, 500);
    }

    // update scene and sceneItem data from layout property change or item tree click event
    private changeSceneSlice(sceneSlice: ISceneTreeSliceResults) {
        this.sceneSlice = sceneSlice;
        this.selectedSceneItemId = sceneSlice.sceneItem.$.id;

        if (isSceneButNotSubScene(sceneSlice.sceneItem)) {
            this.editorHeight = +sceneSlice.sceneItem.Data[0].Layout[0].$.height;
            this.editorWidth = +sceneSlice.sceneItem.Data[0].Layout[0].$.width;
            this.changeWHofEditor();
            this.updateGuideline();
        }

        setTimeout(() => {
            this.containerService.updateResetMoveable(true);
            this.changeDetection();
        });
    }

    // add scene item by drag event from right component
    private addSceneItemByDrag(addBlockData, pos = null) {
        if (!addBlockData) {
            return;
        }

        const addSceneItem: ISceneBlock = addBlockData.block;
        const absolutePos = addBlockData.pos;
        if (this.isMouseOut && !pos && !absolutePos) {
            return;
        }

        const newLayout = addSceneItem.Data[0].Layout[0].$;
        addSceneItem.$.id = _.uniqueId('__');
        let x = 0, y = 0;

        if (pos) {
            x = pos[0];
            y = pos[1];
        } else if (absolutePos) {
            const bounds = this.viewElement.getBoundingClientRect();
            x = absolutePos[0] - bounds.left;
            y = absolutePos[1] - bounds.top;
        } else {
            x = this.mousePosition[0];
            y = this.mousePosition[1];
        }
        newLayout.x = `${Math.max(x, 0)}`;
        newLayout.y = `${Math.max(y, 0)}`;

        if (!newLayout.width || !newLayout.height || newLayout.width == '0' || newLayout.height == '0') {
            newLayout.width = `${DRAG_ITEM_SIZE}`;
            newLayout.height = `${DRAG_ITEM_SIZE}`;
        }

        this.storeSelector.dispatch(actionAddSceneItem({
            sceneId: this.selectedSceneId,
            sceneItemId: this.selectedSceneId,
            updatedItemIds: [addSceneItem.$.id],
            values: [{
                key: 'Player',
                cloneValue: false,
                value: addSceneItem,
                storePath: 'Data["0"].Scene["0"].Players[0]',
                addIndex: addBlockData.addIndex
            }],
        }));

        // Auto-open rich text editor when a RichText block is first added
        if (addSceneItem.$.player === '3243') {
            // Delay to allow the block to be rendered and initialized
            setTimeout(() => {
                this.sceneService.openRichTextEditor(addSceneItem.$.id);
            }, 500);
        }

        /* Alon: 'reorder' action is now happening in the Lib immediately after the actionAddSceneItem
        this.storeSelector.dispatch(actionCRUDScene({
            data: {
                command: 'reorder',
                sceneId: this.selectedSceneId,
                itemIds: []
            }
        }));

         */
    }

    // get scene items to cut or copy
    private getCopyCutSceneItems(command: DuplicateCommand) {
        if (this.selectedItemIds.length > 0) {
            const xy = this.getTopLeftCoordinate();
            const blocks = [];
            this.selectedItemIds.forEach((id) => {
                blocks.push(getPlayerIdInScene([this.sceneData], this.selectedSceneId, id));
            });
            this.storeSelector.dispatch(actionDuplicateScene({
                items: {
                    clipboardBlocks: blocks,
                    topLeftXY: xy
                }
            }));
            this.storeSelector.dispatch(actionDuplicateSceneCommand({command}));
        }
        if (command == 'CUT') {
            this.removeSceneItems();
        }
    }

    //  paste processing
    private pasteSceneItems(pointerXY) {

        // pointXY: mouse pointer position with right click event
        if (!pointerXY ||
            !this.pasteData.clipboardBlocks ||
            this.pasteData.clipboardBlocks.length == 0) return;

        // pasteData.xy: top-left coordinate of selected scene item or items
        let dx = this.pasteData.topLeftXY[0];
        let dy = this.pasteData.topLeftXY[1];
        if (pointerXY[0] == 0 && pointerXY[1] == 0) {
            dx -= this.pasteCount * ADDBLOCK_OFFSET;
            dy -= this.pasteCount * ADDBLOCK_OFFSET;
            this.pasteCount = this.pasteCount % 5 + 1;
        } else {
            dx -= pointerXY[0];
            dy -= pointerXY[1];
        }

        const values = [];
        const addedItemIds = [];

        this.pasteData.clipboardBlocks.forEach((block) => {
            if (!block?.sceneItem?.$.player) {
                return;
            }
            const blockLabelProps: IBlockLabelProp = this.storeSelector.getBlockLabelById(block.sceneItem.$.player);

            if (
                blockLabelProps && this.sceneMimeType && !this.isMainScene
                && (blockLabelProps.jsonPlayerBased || blockLabelProps.jsonItemBased)
                // && mimeType !== SceneMimeTypes.Player
                // && blockLabelProps.types[0] != mimeType
                && !isMimeTypeExists(blockLabelProps.types, this.sceneMimeType)
            ) {
                this.toastr.error(this.translocoService.translate('toast.compPasted', {}, this.translocoService.getActiveLang()));
                return false;
            }

            // get block label and template from scene tree
            // const tmpBlockLabel = this.storeSelector.getBlockLabelByID(block.sceneItem.$.player);
            const tmpBlockData: ISceneBlock = _.cloneDeep(block.sceneItem);

            // reset ID for copy and cut case
            if (this.isCut) {
                tmpBlockData.$.id = block.sceneItem.$.id;
            } else {
                tmpBlockData.$.id = _.uniqueId('__');
            }

            addedItemIds.push(tmpBlockData.$.id);
            tmpBlockData.Data[0].Layout[0].$.x = +block.sceneItem.Data[0].Layout[0].$.x - dx + '';
            tmpBlockData.Data[0].Layout[0].$.y = +block.sceneItem.Data[0].Layout[0].$.y - dy + '';

            // value list to dispatch 'actionAddSceneItem'
            values.push({
                key: 'Player',
                cloneValue: false,
                value: tmpBlockData,
                storePath: 'Data["0"].Scene["0"].Players[0]'
            });
        });

        this.storeSelector.dispatch(actionAddSceneItem({
            sceneId: this.selectedSceneId,
            sceneItemId: this.selectedSceneId,
            updatedItemIds: addedItemIds,
            values
        }));

        /* Alon: 'reorder' action is now happening in the Lib immediately after the actionAddSceneItem
        this.storeSelector.dispatch(actionCRUDScene({
            data: {
                command: 'reorder',
                sceneId: this.selectedSceneId,
                itemIds: []
            }
        }));

         */

        if (this.isCut) {
            this.storeSelector.dispatch(actionDuplicateSceneCommand({
                command: 'PASTE'
            }));
            this.storeSelector.dispatch(actionDuplicateScene({
                items: {
                    clipboardBlocks: [],
                    topLeftXY: [0, 0]
                }
            }));
        }
    }

    // move or resize scene items by key arrow event
    private rotateItemsByKey(kcode, isShift = false) {
        if (this.selectedItemIds.length == 0) {
            return;
        }

        let dr = 1;
        if (kcode == KEY_CODE.LEFT_ARROW) {
            dr = -1;
        }
        if (isShift) {
            dr *= 45;
        }

        const itemGroup = this.selectedIndexList.map((idx) => {
            const item = this.sceneItems[idx];
            const rotation = (+item.rotation + dr) % 360;

            // get updated scene item data
            return this.getPlayerUpdateData(this.sceneItems[idx].id, [{
                key: 'rotation', value: rotation + '',
            }]);
        });

        // store dispatch with updated scene item data
        this.storeSelector.dispatch(actionUpdateSceneItemGroup({items: itemGroup}));
    }

    // move or resize scene items by key arrow event
    private moveResizeItemsByKey(kcode, isShift = false, isCtrl = false) {
        if (this.selectedItemIds.length == 0) {
            return;
        }

        let dx = 0;
        let dy = 0;
        let dw = 0;
        let dh = 0;

        if (kcode == KEY_CODE.LEFT_ARROW) {
            dx = isCtrl ? 0 : isShift ? -1 * MOVE_DIFF[1] : -1 * MOVE_DIFF[0];
            dw = isCtrl && isShift ? -1 * RESIZE_DIFF[1] : isCtrl ? -1 * RESIZE_DIFF[0] : 0;

        } else if (kcode == KEY_CODE.RIGHT_ARROW) {
            dx = isCtrl ? 0 : isShift ? MOVE_DIFF[1] : MOVE_DIFF[0];
            dw = isCtrl && isShift ? RESIZE_DIFF[1] : isCtrl ? RESIZE_DIFF[0] : 0;

        } else if (kcode == KEY_CODE.UP_ARROW) {
            dy = isCtrl ? 0 : isShift ? -1 * MOVE_DIFF[1] : -1 * MOVE_DIFF[0];
            dh = isCtrl && isShift ? -1 * RESIZE_DIFF[1] : isCtrl ? -1 * RESIZE_DIFF[0] : 0;

        } else if (kcode == KEY_CODE.DOWN_ARROW) {
            dy = isCtrl ? 0 : isShift ? MOVE_DIFF[1] : MOVE_DIFF[0];
            dh = isCtrl && isShift ? RESIZE_DIFF[1] : isCtrl ? RESIZE_DIFF[0] : 0;

        } else {
            return;
        }

        const itemGroup = this.selectedIndexList.map((idx) => {
            const item = this.sceneItems[idx];
            const x0 = +item.x;
            const y0 = +item.y;
            const w0 = +item.width;
            const h0 = +item.height;
            const x1 = Math.max(x0 + dx, 0);
            const y1 = Math.max(y0 + dy, 0);
            const w1 = Math.max(w0 + dw, 10);
            const h1 = Math.max(h0 + dh, 10);

            return this.getPlayerUpdateData(this.sceneItems[idx].id, [
                {key: 'width', value: w1 + ''},
                {key: 'height', value: h1 + ''},
                {key: 'x', value: x1 + ''},
                {key: 'y', value: y1 + ''}
            ]);
        });

        // store dispatch with updated scene item data
        this.storeSelector.dispatch(actionUpdateSceneItemGroup({items: itemGroup}));

        // refresh moveable selection handles after keyboard movement
        setTimeout(() => {
            this.containerService.updateResetMoveable(true);
        }, 50);
    }

    // cut, copy, paste by <ctrl + x>, <ctrl + c>, <ctrl + v>
    private cutCopyPasteByKey(kcode) {
        if (kcode == KEY_CODE.X) {
            this.onClickCut();
        } else if (kcode == KEY_CODE.C) {
            this.onClickCopy();
        } else if (kcode == KEY_CODE.V) {
            this.onClickPaste(true);
        } else {
            return;
        }
    }

    // undo, redo by <ctrl + z>, <ctrl + y>
    private undoRedoByKey(kcode) {
        if (kcode == KEY_CODE.BRACKET_LEFT || kcode == KEY_CODE.Z) {
            if (!this.disableUndo) {
                this.onUndoRedo('UNDO');
            }
        } else if (kcode == KEY_CODE.BRACKET_RIGHT || kcode == KEY_CODE.Y) {
            if (!this.disableRedo) {
                this.onUndoRedo('REDO');
            }
        } else {
            return;
        }
    }

    // orient items vertically or horizontally
    private orientSceneItems(isHorizontal = true) {
        if (this.selectedItemIds.length < 2) {
            return;
        }

        const xy = this.getTopLeftCoordinate();

        const groupItems = [];
        this.selectedIndexList.forEach((idx) => {
            groupItems.push(this.sceneItems[idx]);
        });
        // let groupItems = this.sceneItems.filter((item, idx) => this.selectedIndexList.indexOf(idx) > -1);

        if (isHorizontal) {
            groupItems.sort((item1, item2) => +item1.x - +item2.x);
        } else {
            groupItems.sort((item1, item2) => +item1.y - +item2.y);
        }

        let dx = 0;
        let dy = 0;

        const itemGroup = [];
        groupItems.forEach((item) => {
            itemGroup.push(this.getPlayerUpdateData(item.id, [
                {key: 'x', value: xy[0] + dx + ''},
                {key: 'y', value: xy[1] + dy + ''}
            ]));

            if (isHorizontal) {
                dx += +item.width + 10;
            } else {
                dy += +item.height + 10;
            }
        });

        // store dispatch with updated scene item data
        this.storeSelector.dispatch(actionUpdateSceneItemGroup({items: itemGroup}));

        // refresh moveable selection handles after alignment
        setTimeout(() => {
            this.containerService.updateResetMoveable(true);
        }, 50);
    }

    // orient items vertically or horizontally
    alignSceneItems(direction: 'TOP' | 'LEFT' | 'RIGHT' | 'BOTTOM') {
        if (this.selectedItemIds.length < 2) {
            return;
        }

        const xy = this.getTopLeftCoordinate();
        const wh = this.getWidthHeightArea();

        const groupItems = this.selectedIndexList.map((idx) => this.sceneItems[idx]);

        let changedItemGroup = [];
        switch (direction) {
            case 'TOP': {
                changedItemGroup = groupItems.map((item) => {
                    return this.getPlayerUpdateData(item.id, [
                        {key: 'y', value: xy[1] + ''}
                    ]);
                });
                break;
            }
            case 'BOTTOM': {
                changedItemGroup = groupItems.map((item) => {
                    return this.getPlayerUpdateData(item.id, [
                        {key: 'y', value: xy[1] + wh[1] - item.height + ''}
                    ]);
                });
                break;
            }
            case 'LEFT': {
                changedItemGroup = groupItems.map((item) => {
                    return this.getPlayerUpdateData(item.id, [
                        {key: 'x', value: xy[0] + ''}
                    ]);
                });
                break;
            }
            case 'RIGHT': {
                changedItemGroup = groupItems.map((item) => {
                    return this.getPlayerUpdateData(item.id, [
                        {key: 'x', value: xy[0] + wh[0] - item.width + ''}
                    ]);
                });
                break;
            }
            default: {
                return;
            }
        }

        // store dispatch with updated scene item data
        this.storeSelector.dispatch(actionUpdateSceneItemGroup({items: changedItemGroup}));

        // refresh moveable selection handles after alignment
        setTimeout(() => {
            this.containerService.updateResetMoveable(true);
        }, 50);
    }

    // get top-left coordinate of selected items (single or group)
    private getTopLeftCoordinate() {
        if (this.selectedItemIds.length > 0) {
            const ts = new WebKitCSSMatrix((document.querySelector(".moveable-control-box") as HTMLElement).style.webkitTransform);
            return [Math.round(ts.m41 / this.zoom), Math.round(ts.m42 / this.zoom)];
            // return [ts.m41, ts.m42];
        } else {
            return [0, 0];
        }
    }

    // get width and height of selected area (single or group)
    private getWidthHeightArea() {
        const origin = this.getPosAreaCenter();
        return [2 * origin[0], 2 * origin[1]];
    }

    // get x and y of the center of selected area (single or group)
    private getPosAreaCenter() {
        if (this.selectedItemIds.length > 0) {
            const origin = document.querySelector(".moveable-control.moveable-origin");
            const ts = new WebKitCSSMatrix((origin as HTMLElement).style.webkitTransform);
            // return [ts.m41, ts.m42];
            return [Math.round(ts.m41 / this.zoom), Math.round(ts.m42 / this.zoom)];
        } else {
            return [0, 0];
        }
    }

    private getPlayerUpdateData(id: Id, updatedValues: Array<any> = []): ISceneItemsUpdate {
        if (!id || !updatedValues || updatedValues.length == 0) {
            return;
        }

        return {
            sceneId: this.selectedSceneId,
            sceneItemId: id,
            values: updatedValues.map((v) => ({
                key: v.key,
                value: v.value,
                storePath: 'Data["0"].Layout["0"].$'
            }))
        };
    }

    private openRecordForEdit(): void {
        // const saveRecord = preprocessSceneSave(sceneData, null, this.localStoreService.getStorageConfig().studioId, 'add');
        // ...
        // this.appService.lockRecord(this.selectedSceneId);
        // const saveRecord: ICRUDRecord = {
        //     studioId: this.localStoreService.getStorageConfig().studioId,
        //     command: 'edit',
        //     primary: 'player_data_id',
        //     table: 'player_data',
        //     body: {},
        //     id: this.selectedSceneId
        // };
        // this.appService.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
        //     if (!i_crudReply.serverReply.status) {
        //         this.toastr.warning(this.translocoService.translate('toast.failedSave', {}, this.translocoService.getActiveLang()));
        //     }
        // });
    }

    private updateScenePlayers(players) {
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: this.selectedSceneId,
            sceneItemId: this.selectedSceneId,
            values: [{
                key: 'Player',
                value: players,
                storePath: 'Data["0"].Scene["0"].Players["0"]',
                cloneValue: false
            }],
            disableCRUD: true
        }));

        this.storeSelector.dispatch(actionCRUDScene({
            data: {
                command: 'reorder',
                sceneId: this.selectedSceneId,
                itemIds: []
            }
        }));

        this.storeSelector.dispatch({type: 'BREAK_MERGE'});
    }

    // reset width and height of editor element
    private changeWHofEditor() {
        this.editorElement.style.setProperty('width', `${this.editorWidth * this.zoom}px`);
        this.editorElement.style.setProperty('height', `${this.editorHeight * this.zoom}px`);
        // this.editorElement.style.setProperty('width', `${this.editorWidth}px`);
        // this.editorElement.style.setProperty('height', `${this.editorHeight}px`);
    }

    // reset selectable of drag panel
    private resetSelectable(clearSelection: boolean = false) {
        if (!this.drag) return;

        this.moveElements = document.querySelectorAll('#viewSceneContainer .moveable');
        this.drag.setSelectables(this.moveElements);
        if (clearSelection) {
            this.clearSelection();
        }
        // if (this.slideEditMode) {
        //     this.resetTargetSelection();
        // }
        this.cd.detectChanges();
    }

    private clearSelection() {
        if (!this.drag) return;

        if (this.selectedItemIds.length > 0) {
            this.drag.setSelection([], true);
            this.changeSelect = !this.changeSelect;
        }
        this.cd.detectChanges();
    }

    private roundLinePercent(decimal) {
        return Math.round(decimal * 10000) / 10000;
    }

    private resetGuideLines() {
        this.guidelines.horizontal = [];
        this.guidelines.vertical = [];
        this.hidelines = {
            horizontal: [],
            vertical: []
        };
    }

    // private checkLockedScene() {
    //     let isLocked = false;
    //     if (this.lockedRecord) {
    //         const rec = this.lockedRecord.lockedRecords.find((r) => r.table === 'player_data' && r.tableId == this.selectedSceneId);
    //         if (rec && rec.lockId != this.studioId) {
    //             isLocked = true;
    //         }
    //     }
    //     this.lockedScene = isLocked;
    //     this.cd.detectChanges();
    // }

    private resetSelectedIndex() {
        if (this.sceneItems && this.selectedItemIds) {
            this.selectedIndexList = this.selectedItemIds.map((_id) => this.sceneItems.findIndex((i_item) => i_item.id == _id));
        }
    }

    onAbout() {
        this.dialog.open(this.aboutScene, {height: '300px', width: '500px'});
        // throw Error('The app component has thrown an error!');
    }

    onCapture() {
        this.zone.runOutsideAngular(() => {
            this.onClickZoomBack();
            this.resetSelectable(true);
            playSound(9);
            const element = document.getElementsByClassName('root-scene').item(0) as HTMLElement;
            htmlToImage.toJpeg(element, {quality: 0.95})
                .then((dataUrl) => {
                    const link = document.createElement('a');
                    link.download = 'screen-capture.jpeg';
                    link.href = dataUrl;
                    link.click();
                });
        });
        // const a = document.getElementById('viewSceneContainer');
    }

    // onCaptureOld() {
    //     this.zone.runOutsideAngular(() => {
    //         const element: HTMLElement = document.querySelector("#viewSceneContainer");
    //         html2canvas(element).then((canvas) => {
    //             canvas.toBlob((blob) => {
    //                 const link = document.createElement("a");
    //                 link.download = "image.png";
    //                 link.href = URL.createObjectURL(blob);
    //                 link.click();
    //             }, 'image/png');
    //         });
    //     });
    //     // this.toastr.info('generating PDF please be patient!', 'working...', {
    //     //     closeButton: true,
    //     //     disableTimeOut: true,
    //     //     positionClass: 'toast-top-full-width'
    //     // });
    //     // htmlToImage.toCanvas(element)
    //     //     .then(function (canvas) {
    //     //         document.body.appendChild(canvas);
    //     //     });
    //     //
    //     // htmlToImage.toPng(document.getElementById('my-node'))
    //     //     .then(function (dataUrl) {
    //     //         download(dataUrl, 'my-node.png');
    //     //     });
    //     //
    //     // toPng(element)
    //     //     .then(function (dataUrl) {
    //     //         var img = new Image();
    //     //         img.src = dataUrl;
    //     //         document.body.appendChild(img);
    //     //     })
    //     //     .catch(function (error) {
    //     //         console.error('oops, something went wrong!', error);
    //     //     });
    //
    //     // setTimeout(() => {
    //     //     const element: HTMLElement = document.querySelector("#viewSceneContainer");
    //     //     const doc = new jsPDF("landscape", "px", [1920, 1080]);
    //     //     // const doc = new jsPDF({unit: 'px', format: this.pdfOptions.value.pageFormat === 'A4' ? [595, 842] : [842, 1191] });
    //     //     doc.html(element, {
    //     //         callback: (doc: jsPDF) => {
    //     //             // doc.deletePage(doc.getNumberOfPages());
    //     //             doc.save('pdf-export');
    //     //         }
    //     //     });
    //     // }, 200);
    //
    // }

    showLockModal(callback) {
        const msg = this.translocoService.translate('message.overrideChangesv2', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '333px',
            width: '400px',
            data: {name: msg, showCancel: true}
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (callback) callback(!!r);
        });
    }

    private getClickedItem(e) {
        let isSelected = false;
        let isGroup = false;
        let isMoveableControl = false;
        let moveableTarget;
        let node = e.target;

        // Check dragging item is already selected or not.
        while (node != e.currentTarget) {
            // Alon svg ???
            if (!node) break;
            const className = String(node.className);
            if (className.indexOf('moveable') > -1 && className.indexOf('ds-selectable') > -1 && className.indexOf('ds-selected') > -1) {
                isSelected = true;
                moveableTarget = node;
                break;
            } else if (className.indexOf('moveable') > -1 && className.indexOf('ds-selectable') > -1) {
                moveableTarget = node;
                break;
            } else if (className.indexOf('moveable-area') > -1) {
                isGroup = true;
                isSelected = true;
                moveableTarget = node;
                break;
            }
            node = node.parentNode;
        }

        // Alon svg ???
        if (String(e.target.className).indexOf("moveable-control") > -1) {
            isMoveableControl = true;
        }

        return {
            isSelected,
            isGroup,
            isMoveableControl,
            moveableTarget
        };
    }

    openEmbedded() {
        if (!this.user.enterprise) {
            this.appService.openWizardUpgradeDialog(EnumWizardUpgradeToasts.UPGRADE_TO_USE_FEATURE);
            return;
        }
        this.dialog.open(DialogCodeComponent, {width: '500px; height: 800px', data: {sceneId: this.selectedSceneId, codeTemplateId: '2'}});
    }

    copyTextClipboard() {
        copyTextClipboard(this.createSharedUrl());
        this.toastr.info(this.translocoService.translate('toast.copiedToClipboard', {}, this.translocoService.getActiveLang()), '', TOAST_FASTER);
    }

    qrLinkPrint() {
        const dialogRef = this.dialog.open(DialogQrGenerateComponent, {
            height: '400px',
            width: '400px',
            data: {url: this.createSharedUrl()}
        });
    }

    changeRemeberSelection() {
        const v = convertBooleanToNumbers(this.rememberSelection, true);
        this.localStoreService.setStorageValConfig('rememberPreviewSettings', v);
    }

    changePreviewScene(e) {
        this.previewSceneId = e;
        this.createSharedUrl();
    }

    /**
     * Check if selected scene item is playlist or not
     * @param scene item id
     * @returns
     */
    @Memoizee({})
    isPlaylist(sceneItemId) {
        const player = this.players.find((_player) => _player.$.id == sceneItemId);
        return player && player.$.player == this.storeSelector.blockLabels.PLAYLIST.id;
    }

    /**
     * Convert the selected resource item to background. If there already exists background, show confirm and remove it.
     * @returns
     */
    convertToBackground(id: Id = null) {
        if (!id && this.selectedItemIds[0]) {
            id = this.selectedItemIds[0];
        } else if (!id) {
            return;
        }
        const bgId = this.sceneService.getBackgroundImageId();
        if (bgId) {
            // if there already exists background image
            const msg = this.translocoService.translate('message.changeBackgroundv2', {}, this.translocoService.getActiveLang());
            const dialogRef = this.dialog.open(DialogPopComponent, {
                height: '333px',
                width: '400px',
                data: {name: msg, showCancel: true}
            });
            dialogRef.afterClosed().subscribe((r) => {
                if (r) {
                    // this.storeSelector.dispatch(actionRemoveSceneBlocks(this.getPlayerUpdateData(bgId, [
                    //     {key: 'locked', value: 'false'},
                    //     {key: 'isBackground', value: 'false'}
                    // ])));
                    this.setBackground(id);
                    this.removeSceneItems([bgId]);
                }
            });
        } else {
            this.setBackground(id);
        }
    }

    onCustomAction(event) {
        if (!event) return;
        switch (event.action) {
            case "remove": {
                this.removeSceneItems();
                break;
            }
            case "playlistAdd": {
                this.sceneService.openPlaylistAssociateDialog(this.sceneSlice.sceneItem, null);
                break;
            }
            case "labelEdit": {
                // Use different approach for slide edit mode vs standalone
                if (this.slideEditMode) {
                    // In slide editor: simulate natural interaction to work around context issues
                    const itemId = this.selectedItemIds[0];
                    const el: any = document.querySelector(`#${itemId} .editable-label`);
                    if (el) {
                        const clickEvent = new MouseEvent('click', { bubbles: false });
                        const dblClickEvent = new MouseEvent('dblclick', { bubbles: false });
                        el.dispatchEvent(clickEvent);
                        setTimeout(() => {
                            el.dispatchEvent(dblClickEvent);
                            setTimeout(() => {
                                if (document.execCommand) {
                                    document.execCommand('selectAll', false, null);
                                } else {
                                    const range = document.createRange();
                                    range.selectNodeContents(el);
                                    const sel = window.getSelection();
                                    sel.removeAllRanges();
                                    sel.addRange(range);
                                }
                            }, 10);
                        }, 10);
                    }
                } else {
                    // In standalone scene builder: use original method (unchanged)
                    this.convertLabelToEditable(this.selectedItemIds[0]);
                }
                break;
            }
            case "duplicate": {
                this.duplicate();
                break;
            }
            case "jumpScheduler": {
                this.sceneService.jumpToSchedulers(this.sceneSlice.sceneItem.Data[0].Schedule[0].$.id);
                break;
            }
            case "edit": {
                this.showContextMenu(null, event.clientX, event.clientY);
                break;
            }
            case "jump": {
                if (event.nestedSceneSrc) {
                    this.linkToOtherScene(event.nestedSceneSrc);
                }
                break;
            }
            case "touchAction": {
                if (this.slideEditMode && this.touchAction.observed) {
                    // Use TouchLib to handle Playlist→Collection check
                    TouchLib.handleTouchAction(this.selectedSceneId, this.dialog, this.injector);
                }
                break;
            }
            case "richTextEdit": {
                // Open the rich text editor dialog for the selected RichText block
                this.openRichTextEditor();
                break;
            }
        }
    }

    /**
     * Opens the rich text editor dialog for the currently selected RichText block
     */
    private openRichTextEditor() {
        if (this.selectedItemIds.length !== 1) return;
        const itemId = this.selectedItemIds[0];

        // Use scene service to notify the block-rich-text component to open its editor
        this.sceneService.openRichTextEditor(itemId);
    }

    /**
     * Social Media features on preview modal
     */
    selectSocialMedia(checked, value) {
        if (checked) {
            this.socialMediaSelection.select(value);
        } else {
            this.socialMediaSelection.deselect(value);
        }
        this.isSocialPostReady();
    }

    selectResource() {
        this.sceneService.openAssetDialog("RESOURCE:ALL", false, (v) => {
            if (v) {
                this.socialMediaResource = v.sourceData;
                this.socialMediaResourceName = `${this.socialMediaResource.resource_name}.${this.socialMediaResource.resource_type}`;
                this.isSocialPostReady();
            }
        });
    }

    isSocialPostReady() {
        if (isNullOrUndefOrEmpty(this.socialMediaResource)) {
            this.socialPostDisabled = true;
            return false;
        }
        if (isNullOrUndefOrEmpty(this.socialMediaTitle)) {
            this.socialPostDisabled = true;
            return false;
        }
        if (isNullOrUndefOrEmpty(this.appSceneSocialTokenApp2.socialKey)) {
            this.socialPostDisabled = true;
            return false;
        }
        if (this.socialMediaSelection.selected.length === 0) {
            this.socialPostDisabled = true;
            return false;
        } else {
            this.socialPostDisabled = false;
            return true;
        }
    }

    onSocialKeyChanged(e) {
        this.isSocialPostReady();
    }

    postToSocial() {
        if (Lib.IsAccessBlocked(this.user)) {
            this.toastr.error(this.translocoService.translate('account.screenDisruption', {}, this.translocoService.getActiveLang()), '[ Contact live chat ]');
            return false;
        }
        if (!this.isSocialPostReady()) {
            this.cd.markForCheck();
            return;
        }
        this.socialPosting = true;
        this.cod(
            this.storeSelector.getGlobalSettings('ayreshare_token')
                .pipe(take(1))
                .subscribe((globalSettings) => {
                    const a: ISocialToken | any = globalSettings[0]?.param_value;
                    let socialKey: ISocialToken;
                    if (isStringBasedJson(a)) {
                        socialKey = JSON.parse(a) as ISocialToken;
                    } else {
                        socialKey = a as ISocialToken;
                    }
                    if (isNullOrUndefOrEmpty(socialKey)) {
                        return this.toastr.error('invalid social token');
                    }
                    let resourceUrl = '';
                    if (this.socialMediaResource?.resource_id) {
                        resourceUrl = `${this.coreAppData[1].cloudResourcesS3}/business${this.coreAppData[0].businessId}/resources/${this.socialMediaResource.resource_id}.${this.socialMediaResource.resource_type}`;
                    }

                    const previewUrl = this.createSharedUrl() + Math.random();
                    this.storeSelector.dispatch(actionSocialPost({
                        socialKey,
                        resourceUrl,
                        previewUrl,
                        platforms: [this.socialMediaSelection.selected as any],
                        text: this.socialMediaTitle
                    }));
                })
        );

    }

    showAddPlayerModal() {
        this.onSave(() => {}, false);
        StationAddPlayerComponent.createDialog(this.dialog, this.selectedSceneId);
    }

    /**
     * Set background: change layout and locked, order to bottomest.
     * @returns
     */
    private setBackground(id) {
        this.storeSelector.dispatch(actionUpdateSceneItem(this.getPlayerUpdateData(id, [
            {key: 'rotation', value: '0'},
            {key: 'width', value: this.editorWidth + ''},
            {key: 'height', value: this.editorHeight + ''},
            {key: 'x', value: '0'},
            {key: 'y', value: '0'},
            {key: 'locked', value: 'true'},
            {key: 'isBackground', value: 'true'}
        ])));

        this.storeSelector.dispatch({type: 'BREAK_MERGE'});

        setTimeout(() => {
            this.onPushLayers('Bottom', true);
            this.clearSelection();
        });
    }

    private resetTargetSelection() {
        setTimeout(() => {
            this.changeSelect = !this.changeSelect;
            this.changeDetection();
        });
    }

    private checkIsResourceById(id) {
        this.enableBackground = false;
        const resourceSrc = this.sceneService.checkResourceItemById(id);
        if (resourceSrc) {
            this.enableBackground = true;
        }
        return resourceSrc;
    }

    override destroy() {
        super.destroy();
        this.moveElements = [];
        this.preSelectedItem = [];
        if (this.drag != null) {
            this.drag.stop();
            this.drag.selectables = null;
            this.drag = null;
        }
        this.containerService.updateZoom(null);
        this.containerService.updateResetMoveable(false);
        this.containerService.activeSceneItemIds.next(null);

        this.appService.setUploadingFiles([]);
        if (this.lockedScene == 'edit') {
            this.onSave(() => {}, false);
        }

        this.storeSelector.dispatch(actionCRUDScene({
            data: null
        }));
        this.storeSelector.dispatch({type: 'CLEAR'});

        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }


    /**
     * Not used function for now.
     */
    // onDoubleClickMoveable(event) {
    //     this.singleClick = false;
    //     if (event.target.className === 'textarea-wrapper') {
    //         const target = event.target;
    //         let prevSibling = target.previousElementSibling;

    //         while (prevSibling) {
    //             if (prevSibling && prevSibling.tagName === 'TEXTAREA') {
    //                 prevSibling.focus();
    //                 this.textEditMode = true;
    //                 break;
    //             }
    //             prevSibling = prevSibling.previousElementSibling;
    //         }
    //         event.target.remove();
    //     } else if (event.target.tagName === 'TEXTAREA') {
    //         this.textEditMode = true;
    //         event.target.focus();
    //     }
    // }
    // onClickMoveable(event) {
    //     this.singleClick = true;
    //     const tagName = event.target.tagName;
    //     setTimeout(() => {
    //         if (!this.textEditMode && this.singleClick && tagName == 'TEXTAREA') {
    //             const wrapper = document.createElement('div');
    //             wrapper.classList.add('textarea-wrapper');
    //             event.target.insertAdjacentElement("afterend", wrapper);
    //         }
    //     }, 250);
    // }

}
